import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
  AfterViewInit,
  EventEmitter,
  Output,
  TemplateRef
} from '@angular/core';

import { ResourcePlan } from '../../models/resource-plan';
import { CellTooltip } from '@bryntum/grid-thin'; // registra la feature per la grid delle risorse
import { Tooltip, DomHelper } from '@bryntum/core-thin';


import {
  map,
  EMPTY,
  filter,
  switchMap,
  throttleTime,
  tap,
  Observable,
  Subscription,
  take,
  catchError,
  of,
  finalize,
  forkJoin,
} from 'rxjs';

import { BryntumSchedulerProComponent, BryntumSchedulerProProjectModelComponent } from '@bryntum/schedulerpro-angular-thin';
import { Button, EventHelper, StringHelper, TextField, Store, MessageDialog, LocaleManager, DateHelper, Checkbox, DateField } from '@bryntum/core-thin';
import { SchedulerPro, CalendarModel } from '@bryntum/schedulerpro-thin';
import { ColumnStore } from '@bryntum/grid-thin';

import { schedulerProConfig, projectConfig } from './planner-scheduler.config';
import { localeIt } from './locate-it';
import { localeFr } from './locate-fr';
import { localeEs } from './locate-es';

import { PlannerService } from '../../providers/planner.service';
import { FinanceService } from '../../../services/finance.service'
import { UserSessionService } from '../../../services/user-session.service'

import { LibService } from '../../../services/libService'
import { PlanningService } from '../../../services/planning.service'
import { OrderService } from '../../../services/order.service'
import { TranslatorService } from '../../../services/translate.service';
import { ToastrService } from 'ngx-toastr';

import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';

import { MyTimeRangeStore } from './MyTimeRange';
import { CheckBox } from '@syncfusion/ej2-angular-buttons';
import * as moment from 'moment';
import { UserRole } from '../../models/userRole';
import { User } from 'src/app/models/user';
import { Company } from 'src/app/models/company';
import { MatDialog } from '@angular/material/dialog';
import { EditOperatorsDialogComponent } from './components/edit-operators-dialog';
import { plannerRiepilogoDialogComponent } from './riepilogo/planner-riepilogo-dialog';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { TimeAxisColumn, TimeAxisHeaderMenu, VerticalTimeAxisColumn } from '@bryntum/scheduler-thin';


import { IframeModal } from '../../../components/modals/iframe-modal/iframe-modal.component';

import { ModalProjectCosts } from '../../../modals/modal-project-costs/modal-project-costs.component';
import { ModalManpowerHours } from '../../../modals/modal-manpower-hours/modal-manpower-hours.component';


@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'planner-scheduler',
  templateUrl: './planner-scheduler.component.html',
  styleUrls: ['./planner-scheduler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class PlannerSchedulerComponent implements OnInit, AfterViewInit {
  private schedulerPro: SchedulerPro;

  @ViewChild('reopenConfirm') reopenConfirmTpl!: TemplateRef<any>;
  private lastEditFormValue: any | null = null;

  @Output() setPlanningFullScreen = new EventEmitter();
  @Input() fullScreen = false;

  plannerType: string = this.router.url.split('/')[2]
    ? this.router.url.split('/')[2]
    : 'core';

  myTimeRangeStore = new MyTimeRangeStore();

  planningStartDate: any = moment().subtract(7, 'days').toDate();
  planningEndDate: any = moment().add(2, 'months').toDate();
  currentUser: User = this.userSessionService.getState<User>('user')!;

  operatorPlanningSummary: any = {};
  private finalBalancersInFlight = false;
  private lastFinalBalancersKey = '';
  // Stato locale
  private lastPlanningMonthKey?: string;

  private toYMD(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  private monthRangeFor(date: Date): { startYMD: string; endYMD: string; key: string } {
    const start = new Date(date.getFullYear(), date.getMonth(), 1);          // es. 2025-10-01
    const end = new Date(date.getFullYear(), date.getMonth() + 1, 1);        // es. 2025-11-01
    return { startYMD: this.toYMD(start), endYMD: this.toYMD(end), key: `${start.getFullYear()}-${String(start.getMonth() + 1).padStart(2, '0')}` };
  }

  private planningByTL = new Map<number, TLPlanningRow>();
  private consByTL = new Map<number, TLConsRow>();
  private lastMonthKey?: string;

  teamLeaderLabel = 'CAPO SQUADRA';


  columns: any = [
    {
      id: 'name',
      type: 'resourceInfo',
      text: this.translate.instant('PLANNER.CAPOSQUADRA'),
      width: 220,

      // ← tooltip per cella risorsa (richiede cellTooltip abilitato)

      tooltipRenderer: ({ record }: any) => {
        console.log('record', record);
        return `ciao`;
      }
    }
  ];

  private allResourcesById = new Map<number, ResourceBasic>();

  defaultColor: string = "#3F51B5";
  colorList = {
    Black: "#000000",
    Red: "#FF0000",
    Green: "#008000",
    Blue: "#0000FF",
    Maroon: "#800000",
    Olive: "#808000",
    Navy: "#000080",
    Teal: "#008080",
    Fuchsia: "#FF00FF",
    Orange: "#FFA500",
    Crimson: "#DC143C",
    DarkGoldenRod: "#B8860B",
    DarkMagenta: "#8B008B",
    SaddleBrown: "#8B4513",
    FireBrick: "#B22222",
    Chocolate: "#D2691E",
    DarkOrange: "#FF8C00",

    White: "#FFFFFF",
    Gray: "#808080",
    Silver: "#C0C0C0",
    DimGray: "#696969",
    LightGray: "#D3D3D3",
    Gainsboro: "#DCDCDC",

    Yellow: "#FFFF00",
    Gold: "#FFD700",
    GoldenRod: "#DAA520",
    Khaki: "#F0E68C",
    DarkKhaki: "#BDB76B",

    Lime: "#00FF00",
    LimeGreen: "#32CD32",
    ForestGreen: "#228B22",
    SeaGreen: "#2E8B57",
    MediumSeaGreen: "#3CB371",
    DarkSeaGreen: "#8FBC8F",
    SpringGreen: "#00FF7F",
    MediumSpringGreen: "#00FA9A",
    Chartreuse: "#7FFF00",
    YellowGreen: "#9ACD32",
    OliveDrab: "#6B8E23",

    Turquoise: "#40E0D0",
    MediumTurquoise: "#48D1CC",
    DarkTurquoise: "#00CED1",
    LightSeaGreen: "#20B2AA",

    SkyBlue: "#87CEEB",
    LightSkyBlue: "#87CEFA",
    DeepSkyBlue: "#00BFFF",
    DodgerBlue: "#1E90FF",
    CornflowerBlue: "#6495ED",
    RoyalBlue: "#4169E1",
    MediumBlue: "#0000CD",
    SteelBlue: "#4682B4",
    LightSteelBlue: "#B0C4DE",
    SlateBlue: "#6A5ACD",
    DarkSlateBlue: "#483D8B",
    MidnightBlue: "#191970",

    Purple: "#800080",
    Indigo: "#4B0082",
    BlueViolet: "#8A2BE2",
    DarkViolet: "#9400D3",
    DarkOrchid: "#9932CC"
  };

  colorValues = Object.values(this.colorList);
  // mappa: userId -> Set('YYYY-MM-DD')
  private absencesByUser: Record<string, Set<string>> = {};
  private absencesDetailsByUser: Record<string, Array<{ ymd: string; hours: number | null; causalCode: string | null }>> = {};
  private clickTip?: any; // Tooltip

  private fmt(date: Date): string {
    // YYYY-MM-DD
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  private fmtt(n: number, digits = 0): string {
    return typeof n === 'number' ? n.toLocaleString('it-IT', { minimumFractionDigits: digits, maximumFractionDigits: digits }) : '';
  }

  private unixToYMD(tsSec: number): string {
    const d = new Date(tsSec * 1000);
    const y = d.getUTCFullYear();
    const m = String(d.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(d.getUTCDate()).padStart(2, '0');
    return `${y}-${m}-${dd}`;
  }

  private fmtEUR(v: number) {
    return (Number.isFinite(v) ? v : 0).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
  }
  private fmtPerc(v: number, digits = 2) {
    const n = Number.isFinite(v) ? v : 0;
    return `${n.toLocaleString('it-IT', { minimumFractionDigits: digits, maximumFractionDigits: digits })}%`;
  }
  private pctClass(name: 'mat' | 'mdo' | 'mlc', value: number) {
    const v = Number.isFinite(value) ? value : 0;
    if (name === 'mat' && v > 10) return 'color:#c62828;';
    if (name === 'mdo' && v > 37) return 'color:#c62828;';
    if (name === 'mlc' && v < 55) return 'color:#c62828;';
    return '';
  }

  private normalizeAbsences(raw: any): Array<{ userId: number; ymd: string; hours: number | null; causalCode: string | null }> {
    const rows: any[] = raw?.item?.Table ?? raw?.items ?? raw?.data ?? raw ?? [];
    return rows
      .map((r: any) => {
        const userId =
          r.userId ?? r.idUser ?? r.id ?? r.UserId ?? r.IdUser ?? r.Id;

        const dateRaw =
          r.date ??
          r.day ??
          r.startDate ??
          r.Date ??
          r.Day ??
          r.StartDate ??
          r.EffectiveDate;

        if (!userId || !dateRaw) return null;

        const dt = new Date(dateRaw);
        const ymd = `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, '0')}-${String(dt.getUTCDate()).padStart(2, '0')}`;


        const hours = (r.Hours ?? r.hours ?? r.amountHours ?? r.NumHours ?? r.numHours);
        const causalCode = r.causalCode ?? r.CausalCode ?? null;

        return {
          userId: Number(userId),
          ymd,
          hours: hours == null ? null : Number(hours),
          causalCode
        };
      })
      .filter(Boolean) as Array<{ userId: number; ymd: string; hours: number | null; causalCode: string | null }>;
  }


  private fetchAbsencesForRange(): Observable<void> {
    const currentUser = this.userSessionService.getState('user');
    const start = this.fmt(this.planningStartDate);
    const end = this.fmt(this.planningEndDate);

    return this.financeService
      .getWorkdayAbsence(currentUser.email, this.getCompany(), start, end)
      .pipe(
        map(res => {
          this.absencesByUser = {};
          this.absencesDetailsByUser = {};
          const rows = this.normalizeAbsences(res);

          for (const r of rows) {
            const key = String(r.userId);

            // Set per lookup veloce (compatibilità con il resto)
            if (!this.absencesByUser[key]) this.absencesByUser[key] = new Set();
            this.absencesByUser[key].add(r.ymd);

            // Dettagli (ore + causale per giorno)
            if (!this.absencesDetailsByUser[key]) this.absencesDetailsByUser[key] = [];
            this.absencesDetailsByUser[key].push({
              ymd: r.ymd,
              hours: r.hours,
              causalCode: r.causalCode
            });
          }
        })
      );

  }




  cls = 'custom-style';
  consuntivoLabel = this.translate.instant('SIDEBAR.Consuntivi');
  eventiLabel = this.translate.instant('LABEL.Certificati');
  apriPraticaLabel = this.translate.instant('LABEL.ApriPratica');
  projectCostsLabel = this.translate.instant('LABEL.projectCosts');
  manpowerHoursLabel = this.translate.instant('LABEL.manpowerHours');

  calendars: any = [
    // Calendar definition
    {
      id: 'weekends',
      name: 'Weekends',
      // Intervals to define all SA and SU as non-working days
      intervals: [
        {
          recurrentStartDate: 'on Sat at 0:00',
          recurrentEndDate: 'on Mon at 0:00',
          isWorking: false,
        },
      ],
    },
  ];

  timeRanges: any = [
    {
      id: 1,
      name: '',
      recurrenceRule: 'FREQ=WEEKLY;BYDAY=SU;',
      startDate: '2021-07-14 00:00',
      endDate: '2021-07-15 00:00',
    },
    {
      id: 2,
      name: '',
      recurrenceRule: 'FREQ=WEEKLY;BYDAY=SA;',
      startDate: '2021-07-14 00:00',
      endDate: '2021-07-15 00:00',
    },
  ];

  eventLayout: any = {
    type: 'stack',
    //groupBy: (event: any) => (event.prio === 'high' ? 1 : 2)
    groupBy: 'prio',
  };

  hashCode(text: any) {
    var hash = 0,
      i,
      chr;
    if (text.length === 0) return hash;
    for (i = 0; i < text.length; i++) {
      chr = text.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }

  features: any = {
    resourceTimeRanges: {
      enableResizing: false,
      showHeaderElements: false,
      renderer({ }) {
        // Renderizza un div-icona dentro ogni range con classe stabile
        return '<div class="absence-cell-icon" aria-hidden="true"></div>';
      }
    },
    dependencyEdit: false,
    dependencies: false,
    filterBar: true,
    timeAxisHeaderMenu: {
      items: {
        dateRange: false,
        eventsFilter: false,
        zoomLevel: false,
        currentTimeLine: false,
      }
    },
    percentBar: {
      allowResize: false,
      showPercentage: false, // showing a tooltip instead
    },
    timeRanges: {
      enableResizing: false,
      showCurrentTimeLine: false,
      showHeaderElements: false,
    },
    nonWorkingTime: true,
    eventNonWorkingTime: {
      enableResizing: true,
    },
    cellEdit: false,
    cellMenu: {
      items: {
        removeRow: false,
      },
    },

    eventTooltip: {
      allowOver: true,
      trackMouse: false,
      anchorToTarget: true,
      align: 'l-r',
      cls: 'planner-event-tip',
      template: (data: any) => {
        const get = (k: string) => data.eventRecord.get(k);
        const has = (k: string) => {
          const v = get(k);
          if (Array.isArray(v)) return v.length > 0;
          return v !== null && v !== undefined && v !== '';
        };

        const hasAny = (...keys: string[]) => keys.some(has);
        const weekDays = get('weekDays');
        const hasDay = (abbr: string) => Array.isArray(weekDays) && weekDays.includes(abbr);

        // — intestazione base
        const parts: string[] = [];
        parts.push('<dl class="tt-rows tt-tight">');

        if (has('code')) parts.push(`<dt>${this.translate.instant('PLANNER.CODE_COMMESSA')}:</dt><dd>${get('code')}</dd>`);
        if (has('clientName')) parts.push(`<dt>${this.translate.instant('PLANNER.SUBJ')}:</dt><dd>${get('clientName')}</dd>`);
        if (has('nameBuilding')) parts.push(`<dt>${this.translate.instant('PLANNER.Edificio')}:</dt><dd>${get('nameBuilding')}</dd>`);
        if (has('assistantsName')) {
          parts.push(
            `<dt>${this.translate.instant('PLANNER.WORKER_ASSISTANT')}:</dt><dd>- ${get('assistantsName').join('<br>- ')}</dd>`
          );
        }

        // — ore
        if (hasAny('OrderHoursTotal', 'TaskHoursTotal', 'PassiveHoursTotal') || true /* cashflow a seguire */) {
          parts.push('<hr>');
          if (has('OrderHoursTotal')) parts.push(`<dt>${this.translate.instant('PLANNER.OreDeliberate')}:</dt><dd>${get('OrderHoursTotal')}</dd>`);
          if (has('TaskHoursTotal')) parts.push(`<dt>${this.translate.instant('PLANNER.OrePianificate')}:</dt><dd>${get('TaskHoursTotal')}</dd>`);
          if (has('PassiveHoursTotal')) parts.push(`<dt>${this.translate.instant('PLANNER.OreConsuntivate')}:</dt><dd>${get('PassiveHoursTotal')}</dd>`);
          parts.push(this.cashFlowToolTipSection(data) ?? '');
        }

        parts.push(this.mlcToolTipSectionFlat(data) ?? '');

        // — quantità
        if (hasAny('deliberateQuantityToBeProduced', 'totalSAL', 'weekSAL')) {
          parts.push('<hr>');
          if (has('deliberateQuantityToBeProduced'))
            parts.push(`<dt>${this.translate.instant('PLANNER.QuantitaTotaleDeliberata')}:</dt><dd>${get('deliberateQuantityToBeProduced')}</dd>`);
          if (has('totalSAL'))
            parts.push(`<dt>${this.translate.instant('PLANNER.QuantitaTotaleProdotta')}:</dt><dd>${get('totalSAL')} ( ${get('percentDone')}% )</dd>`);
          if (has('weekSAL'))
            parts.push(`<dt>${this.translate.instant('PLANNER.QuantitaSettimanaleProdotta')}:</dt><dd>${get('weekSAL')} ( ${get('weekSALpercent')}% )</dd>`);
        }

        // — valori
        // if (hasAny('deliberateValueToBeProduced', 'totalSALValue', 'weekSALValue')) {
        if (hasAny('totalSALValue', 'weekSALValue')) {
          parts.push('<hr>');
          // if (has('deliberateValueToBeProduced'))
          //   parts.push(`<dt>${this.translate.instant('PLANNER.ValoreTotaleDeliberato')}:</dt><dd>${get('deliberateValueToBeProduced')}€</dd>`);
          if (has('totalSALValue'))
            parts.push(`<dt>${this.translate.instant('PLANNER.ValoreTotaleProdotto')}:</dt><dd>${get('totalSALValue')} ( ${get('totalSALValuePercent')}% )</dd>`);
          if (has('weekSALValue'))
            parts.push(`<dt>${this.translate.instant('PLANNER.ValoreSettimanaleProdotto')}:</dt><dd>${get('weekSALValue')} ( ${get('weekSALValuePercent')}% )</dd>`);
        }

        // — giorni consuntivati (tabella) se presente weekDays
        if (Array.isArray(weekDays)) {
          parts.push('<hr>');
          parts.push(`${this.translate.instant('PLANNER.GGCONSUNTIVATI')}:`);
          parts.push(`<table class="consTable">
      <th class="${hasDay('Mo') ? 'mark' : ''}">L</th>
      <th class="${hasDay('Tu') ? 'mark' : ''}">M</th>
      <th class="${hasDay('We') ? 'mark' : ''}">M</th>
      <th class="${hasDay('Th') ? 'mark' : ''}">G</th>
      <th class="${hasDay('Fr') ? 'mark' : ''}">V</th>
      <th class="${hasDay('Sa') ? 'mark' : ''}">S</th>
      <th class="${hasDay('Su') ? 'mark' : ''}">D</th>
      </table>`);
        }
        // — note (se presenti)
        const rawNotes = get('notes');
        if (rawNotes && String(rawNotes).trim().length) {
          parts.push('<hr>');
          const safe = StringHelper.encodeHtml(String(rawNotes)).replace(/\n/g, '<br>');
          parts.push(`<dt>${this.translate.instant('PLANNER.NOTE') || 'Note'}:</dt>`);
          parts.push(`<dd class="tt-notes">${safe}</dd>`);
        }

        parts.push('</dl>');
        return parts.join('');
      },
    },
    taskEdit: false,
    eventMenu: this.getEventMenu(this),
    scheduleMenu: {
      items: {
        // Remove "Add event" default item
        addEvent: false,
      },
    },
  };

  getEventMenu(angular: any) {

    let structure = {
      items: {

        reset: {
          ref: 'reset',
          text: 'Reset',
          icon: 'b-fa b-fa-fw b-fa-xmark',
          weight: 520,
          onItem: ({ eventRecord }: any) =>
            this.resetOfThePlannedOrder(eventRecord),
        },

        consuntivazione: {
          ref: 'consuntivazione',
          text: this.consuntivoLabel,
          icon: 'b-fa b-fa-fw b-fa-wallet',
          weight: 520,
          onItem: ({ eventRecord }: any) => this.linkToFinalBalancer(eventRecord),
        },

        eventi: {
          ref: 'eventi',
          text: this.eventiLabel,
          icon: 'b-fa b-fa-file-invoice-dollar',
          weight: 520,
          onItem: ({ eventRecord, resourceRecord }: any) => {
            const orderCode = eventRecord.get('code') ?? eventRecord.get('orderCode');

            const params = new URLSearchParams({
              orderCode: String(orderCode ?? ''),
            });

            window.open(`/certificates?${params.toString()}`, '_blank');
          }
        },
        apriPratica: {
          ref: 'apriPratica',
          text: this.apriPraticaLabel,
          icon: 'b-fa b-fa-fw b-fa-folder-open',
          weight: 518, // vicino a "eventi"
          onItem: ({ eventRecord }: any) => {
            // prova a leggere il codice commessa/pratica
            const practiceCode =
              eventRecord.get('code') ??
              eventRecord.get('orderCode') ??
              eventRecord.get('orderId');

            if (!practiceCode) {
              console.warn('Codice pratica non disponibile per questo evento');
              return;
            }

            const url = `/practices/${encodeURIComponent(String(practiceCode).trim())}`;

            // Apri nella stessa scheda (coerente con "mi rimanda alla pagina");
            // se preferisci una nuova scheda, usa '_blank'
            window.open(url, '_self');
          }
        },



        pos: {
          ref: 'pos',
          text: 'POS',
          icon: 'b-fa b-fa-file-invoice-dollar',
          weight: 520,
          onItem({ eventRecord }: any) {
            angular.openIframePOS(eventRecord.code)
          },
        },

        projectCosts: {
          ref: 'projectCosts',
          text: this.projectCostsLabel,
          icon: 'b-fa b-fa-screwdriver-wrench',
          weight: 520,
          onItem({ eventRecord }: any) {
            angular.openProjectCosts(eventRecord.code)
          },
        },

        manpowerHours: {
          ref: 'manpowerHours',
          text: this.manpowerHoursLabel,
          icon: 'b-fa b-fa-person-digging',
          weight: 520,
          onItem({ eventRecord }: any) {
            angular.openManpowerHours(eventRecord.code, eventRecord.version)
          },
        },

        // Edit a built in item
        editEvent: {},

        // Hide a built in item
        unassignEvent: false,
        splitEvent: false,
        cutEvent: false,
      },
    }
    return structure
  }

  openProjectCosts(code: any) {
    let currentUser = this.userSessionService.getState('user');
    const dialogRef = this.dialog.open(ModalProjectCosts, {
      width: '70%',
      data: {
        code: code,
        account: currentUser.email,
      },
      scrollStrategy: new NoopScrollStrategy(),

    });
  }

  openManpowerHours(code: any, version: any) {
    const dialogRef = this.dialog.open(ModalManpowerHours, {
      width: '70%',
      data: {
        code: code,
        version: version,
      },
      scrollStrategy: new NoopScrollStrategy(),
    });

    dialogRef.afterClosed().subscribe((result: any) => {

    });
  }

  openIframePOS(code: any) {
    let currentUser = this.userSessionService.getState('user');
    const dialogRef = this.dialog.open(IframeModal, {
      width: '1600px',
      data: {
        urlDocComposition: 'DocumentComposition/POS?commessa=',
        practiceCode: code,
        token: currentUser.email
      },
      scrollStrategy: new NoopScrollStrategy(),

    });

    dialogRef.afterClosed().subscribe((result: any) => {

    });
  }



  tbarConfig = {
    items: [
      {
        type: 'textfield',
        ref: 'filterByName',
        icon: 'b-fa b-fa-filter',
        placeholder: this.translate.instant('PLANNER.cercacommessa'),
        clearable: true,
        width: '15em',
        keyStrokeChangeDelay: 100,
        triggers: {
          filter: {
            align: 'start',
            cls: 'b-fa b-fa-filter',
          },
        },
      },
      {
        type: 'checkbox',
        ref: 'showFinalBalances',
        label: this.translate.instant('PLANNER.Consuntivi'),
        checked: false,
      },
      {
        type: 'button',
        ref: 'editOperators',
        icon: 'b-icon-edit',
        text: this.translate.instant('PLANNER.modifica_operatori'),
      },
      {
        type: 'datefield',
        ref: 'startDateField',
        width: 130,
        editable: false,
        step: 1,
        value: this.planningStartDate
      },
      {
        type: 'datefield',
        ref: 'endDateField',
        width: 130,
        editable: false,
        step: 1,
        value: this.planningEndDate
      },
      '->',
      {
        type: 'button',
        id: 'fullPlanning',
        ref: 'fullPlanning',
        icon: 'b-icon-fullscreen',
        text: '',
      },
      {
        type: 'button',
        ref: 'loadTasksButton',
        icon: 'b-icon-sync',
        text: '',
      },
      {
        type: 'button',
        ref: 'zoomInButton',
        icon: 'b-icon-search-plus',
        text: 'Zoom in',
      },
      {
        type: 'button',
        ref: 'zoomOutButton',
        icon: 'b-icon b-icon-search-minus',
        text: 'Zoom out',
      },
    ],
  };

  listeners = {};

  cashFlowToolTipSection(data: any) {
    let text: any = ``
    if (data.eventRecord.get('valueSold')?.toString() && data.eventRecord.get('currentDownPaymentPercentage')?.toString()) text += `<hr>`

    // if (data.eventRecord.get('valueSold')?.toString()) {
    //   text += `<dt>${this.translate.instant('PLANNER.Venduto')}</dt><dd>${data.eventRecord.get('valueSold')}</dd>`
    // }
    if (data.eventRecord.get('currentDownPaymentPercentage')?.toString()) {
      let firstStepPercentage = ``
      if (data.eventRecord.get('firstStepPercentage')?.toString()) firstStepPercentage = `del ${data.eventRecord.get('firstStepPercentage')}%`
    }
    return text;
  }

  linkToFinalBalancer(eventRecord: any) {
    let workingCompany = this.userSessionService.getState('working_company');

    if (this.isDubaiPractice(workingCompany?.country)) {
      window.open(
        `/final-balancer-d`,
        '_blank'
      );
    } else {
      window.open(
        `/final-balancer/${eventRecord.code}/${eventRecord.version}`,
        '_blank'
      );
    }

  }

  isDubaiPractice(country: string) {
    return ['AE', 'KW', 'NP', 'SA'].includes(country)
  }

  resetOfThePlannedOrder(eventRecord: any) {
    console.log('RESET');
    console.log(eventRecord);

    let orderId = eventRecord.orderId;

    MessageDialog.confirm({
      title: 'Reset schedule',
      message: 'Are you sure you want to reset the schedule?',
    }).then((result: any) => {
      if (result === 1) {
        this.planningService.resetPlanning(orderId).subscribe(
          (responseData: any) => {
            this.loadTasks(true);
            //context.finalize(true);
          },
          (err) => {
            //context.finalize(false);
          }
        );
      } else {
        // context.finalize(false);
      }
    });
  }

  /*
  eventRenderer({ eventRecord, resourceRecord, renderData }: any) {
    renderData.cls[`b-type-${eventRecord.type}`] = 1;

    return [
        {
            class    : 'header',
            children : [
                {
                    class    : 'progress-outer',
                    children : [{
                        class : 'progress-fill',
                        style : {
                            width : (eventRecord.progress || 50) + '%'
                        }
                    }]
                },
                {
                    class : 'b-fa b-fa-ellipsis'
                }
            ]
        },
        {
            class    : 'footer',
            children : [
                eventRecord.type === 'meeting' ? {
                    class : 'b-fa b-fa-people-group'
                } : null,
                {
                    tag  : 'span',
                    text : eventRecord.name
                },

            ]
        }
    ];
}
*/
  private fmtNum(v: any, digits = 2) {
    return (v === null || v === undefined || v === '' || isNaN(Number(v)))
      ? '-' : Number(v).toFixed(digits);
  }
  private fmtPct(v: any, digits = 2) {
    return (v === null || v === undefined || v === '' || isNaN(Number(v)))
      ? '-' : `${Number(v).toFixed(digits)}%`;
  }

  mlcToolTipSectionFlat(data: any) {
    const t = (k: string, fb: string) => this.translate.instant(k) || fb;

    // --- helpers di formattazione ---
    const fmtNum = (v: any) => Number(v || 0).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const fmtCur = (v: any) => `${fmtNum(v)}€`;
    const fmtPct = (v: any) => `${Number(v || 0).toFixed(2)}%`;

    // --- helper lettura sicura ---
    const rec = data?.eventRecord ?? {};
    const getN = (k: string) => Number(rec.get?.(k) ?? (rec as any)[k] ?? 0);

    // ---- dati base dagli eventi / metriche ----
    const valueSold = getN('valueSold');                       // Venduto
    const incassato = getN('ValoreIncassato');                 // Incassato (importo)
    const PercIncMDO = getN('PercIncMDO');
    const fatturato = getN('ValoreFatturato');                 // Fatturato (importo)

    const totalValoreSal = getN('totalValoreSal');             // Totale prodotto (lordo)
    const storni = getN('ValoreStorni');               // Storni prodotto
    const prodNetto = totalValoreSal - storni;            // Prodotto netto

    const delibLordo = getN('deliberateValueToBeProduced');
    const storniDelib = getN('ValoreStorniDelibera');       // <-- nuovo campo
    const delibNetto = delibLordo - storniDelib;

    const valMateriali = getN('ValoreMateriali');
    const valOreMlc = getN('valoreOreMlc');

    const percFatturato = getN('PercentFatturato');           // già calcolate a monte
    const percIncassato = getN('PercentIncassato');

    // ---- nuovi calcoli richiesti ----
    // % Avanzamento = (prodotto netto) / (deliberato netto) * 100
    const percAvanz = (delibNetto > 0) ? (prodNetto / delibNetto) * 100 : 0;

    // Costo materiale % = materiali / (prodotto netto) * 100
    const percMateriale = (prodNetto > 0) ? (valMateriali / prodNetto) * 100 : 0;

    // MLC valore = prodotto netto - ore MLC - materiali
    const mlcVal = (prodNetto - valOreMlc - valMateriali);

    // MLC % = MLC valore / (prodotto netto) * 100
    const mlcPct = (prodNetto > 0) ? (mlcVal / prodNetto) * 100 : 0;

    // Media Netta (stessa formula che usavi per “lorda”)
    const mediaNetta = (valOreMlc > 0)
      ? (((8 * (totalValoreSal - valMateriali)) / valOreMlc) * 2)
      : 0;

    // ---- SEZIONE in ordine come il foglio ----
    // NB: qui includo solo i campi di questa sezione; le intestazioni (codice, soggetto, ecc.)
    //     restano dove le stai già costruendo.
    let html = '';

    // Venduto / Incassato (importi, sempre visibili)
    html += `<dt>${t('PLANNER.Venduto', 'Venduto')}</dt><dd>${fmtCur(valueSold)}</dd>`;
    // html += `<dt>${t('PLANNER.IncassatoImporto', 'Incassato')}</dt><dd>${fmtCur(incassato)}</dd>`;

    // righello
    html += `<hr>`;

    // MLC (valore + %)
    html += `<dt>${t('PLANNER.MLC', 'MLC')}</dt><dd>${fmtCur(mlcVal)} (${fmtPct(mlcPct)})</dd>`;

    // Media Netta
    html += `<dt>${t('PLANNER.MediaNetta', 'Media Netta')}</dt><dd>${fmtNum(mediaNetta)}€</dd>`;

    // % Avanzamento (nuova formula)
    html += `<dt>${t('PLANNER.PercentAvanzamento', 'Percentuale Avanzamento')}</dt><dd>${fmtPct(percAvanz)}</dd>`;

    // Costo materiale: importo + %
    html += `<dt>${t('PLANNER.CostoMateriale', 'Costo Materiale')}</dt><dd>${fmtCur(valMateriali)} (${fmtPct(percMateriale)})</dd>`;

    // html += `<dt>Percentuale incidenza MDO</dt><dd>0%</dd>`;
    html += `<dt>${t('PLANNER.PercIncMDO', 'Percentuale incidenza MDO')}</dt><dd>${fmtPct(PercIncMDO)}</dd>`;


    // % Fatturato / % Incassato
    html += `<dt>${t('PLANNER.PercentFatturato', 'Percentuale Fatturato')}</dt><dd>${fmtPct(percFatturato)}</dd>`;
    html += `<dt>${t('PLANNER.PercentIncassato', 'Percentuale Incassato')}</dt><dd>${fmtPct(percIncassato)}</dd>`;

    // Valori Fatturato / Incassato
    html += `<dt>${t('PLANNER.ValoreFatturato', 'Valore Fatturato')}</dt><dd>${fmtCur(fatturato)}</dd>`;
    // html += `<dt>${t('PLANNER.ValoreFatturato', 'Valore Fatturato')}</dt><dd>${fmtCur(fatturato)}</dd>`;
    html += `<dt>${t('PLANNER.ValoreIncassato', 'Valore Incassato')}</dt><dd>${fmtCur(incassato)}</dd>`;

    // Valore totale deliberato NETTO (delib - storni delibera)
    html += `<hr>`;
    html += `<dt>${t('PLANNER.ValoreTotaleDeliberato', 'Valore Totale Deliberato')}</dt><dd>${fmtCur(delibNetto)}</dd>`;

    return html;
  }





  goToFinalBalancer(code: any, version: any) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/final-balancer/', `${code}`, `${version}`])
    );

    window.open(url, '_blank');
  }
  resources: any = [];

  events: any = [];

  assignments: any = [
    { event: 1, resource: 1 },
    { event: 2, resource: 2 },
  ];

  dependencies: any = [];

  schedulerProConfig = schedulerProConfig;
  projectConfig = projectConfig;

  ordersView: any = false;

  public teamLeaders: any = [];
  public assistants: any = [];
  public resourcesList: any = [];
  public assistantOptions: any = [];

  //@ViewChild('schedulerpro') schedulerProComponent!: BryntumSchedulerProComponent;
  @ViewChild(BryntumSchedulerProComponent)
  schedulerProComponent: BryntumSchedulerProComponent;
  @ViewChild('project')
  projectComponent!: BryntumSchedulerProProjectModelComponent;

  rawTasks: any = [];

  public orderCodes: any = [];
  public orderIds: any = [];

  public eventStructure = [];
  public tasksCodeStructure: any = {};
  public finalBalancesCodeStructure: any = {};

  public tasksEvents: any = [];
  public finalBalancesEvents: any = [];

  public tasksWithFinalBalancesEvents: any = [];
  public tasksWithFinalBalancesAssignments: any = [];

  public tasksAssignments: any = [];
  public finalBalancesAssignments: any = [];
  orderColors: any = {};

  constructor(
    private plannerService: PlannerService,
    private financeService: FinanceService,
    private userSessionService: UserSessionService,
    private libService: LibService,
    private planningService: PlanningService,
    private orderService: OrderService,
    public translate: TranslatorService,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
  ) { }

  // getAndSetOrderColor(orderCode: any) {
  //   let color = this.getRandomColor();
  //   if (!this.orderColors[orderCode]) this.orderColors[orderCode] = color;
  //   return this.orderColors[orderCode];
  // }

  getNextDay(startDate: any, numberOfDays: any) {
    let start = moment(startDate, 'YYYY-MM-DD');
    return start.add(numberOfDays, 'days');
  }

  changeColumsStructure(event: any) {
    this.ordersView = event.checked;
    this.changeViewPlanning();
  }

  changeViewPlanning() {
    const columns = this.schedulerPro.columns as ColumnStore;
    if (this.ordersView) {
      this.loadOrders(true);
      columns.get('name').text = this.translate.instant('PLANNER.ORDER_LIST');
    } else {
      this.initLoadTasks(true);
      columns.get('name').text = this.translate.instant('PLANNER.CAPOSQUADRA');
    }
  }

  initLoadTasks(loading: any = false) {
    this.getResources();
    this.loadTasks(loading);
  }

  resetFilterByName() {
    // Ripulisce il campo che filtra sulla base del nome della commessa
    if (this.schedulerPro) {
      const { filterByName } = this.schedulerPro.widgetMap as {
        filterByName: TextField;
      };
      filterByName.clear();
    }
  }
  /** Ritorna true se QUALSIASI partecipante ha assenza in QUALSIASI giorno della lista (ts UNIX, sec) */
  private hasAbsenceFor(daysTsSec: number[], participantIds: Array<number | null | undefined>): boolean {
    const daysYMD = (daysTsSec || []).map(ts => this.unixToYMD(Number(ts)));
    const uniqParticipants = [...new Set(participantIds.filter((v): v is number => typeof v === 'number' && !Number.isNaN(v)))];

    for (const uid of uniqParticipants) {
      const set = this.absencesByUser[String(uid)];
      if (!set) continue;
      for (const d of daysYMD) {
        if (set.has(d)) return true;
      }
    }
    return false;
  }

  /** Sceglie l’iconcina finale combinando cashflow mancante e assenze */
  private iconFor(cashflowMissing: boolean, hasAbsence: boolean): string {
    return this.pickIconCls(cashflowMissing, hasAbsence); // tieni una sola funzione “sorgente di verità”
  }

  loadOrders(loading: any = false) {
    console.log('LOAD ORDERS');
    if (loading) this.libService.lockPage('');
    let currentUser = this.userSessionService.getState('user');

    this.resetFilterByName();

    // Reset Variabili
    this.tasksCodeStructure = {};
    this.tasksEvents = [];
    this.tasksAssignments = [];

    this.planningService
      .getOrdersWithTasks(currentUser.email, currentUser.id, this.getCompany())
      .subscribe((orders: any) => {
        let tmp_code: any = {};
        if ([null, undefined].includes(orders)) {
          this.schedulerPro.resourceStore.removeAll();
        } else {
          let orderResources = orders.map((order: any) => {
            return {
              id: order.id,
              name: `${order.code} - ${!['', null, undefined].includes(order.nameSubject)
                ? order.nameSubject
                : order.nameAdminCondominius
                } - ${order.nameBuilding} - ${order.city}`,
            };
          });
          this.schedulerPro.resourceStore.removeAll();

          orderResources.forEach((resource: any) => {
            this.schedulerPro.resourceStore.add(resource);
          });
          this.rebuildAbsenceDayMarkers();

          orders.forEach((order: any) => {
            order.Tasks.forEach((task: any) => {
              let tmpDate = this.getDateFromTimestampInPieces(task.tsStart);
              let tmpDateEnd = this.getDateFromTimestampInPieces(task.tsEnd);
              let week = moment(
                `${tmpDate.year}-${tmpDate.month + 1}-${tmpDate.day}`,
                'YYYY-MM-DD'
              ).format('WW');
              let weekCode = `${tmpDate.year}_${week}`;

              // let taskCode = task.code
              let taskCode = `${order.code}_${weekCode}`;

              let old = true;

              let startDate = moment(
                `${tmpDate.year}-${tmpDate.month + 1}-${tmpDate.day}`,
                'YYYY-MM-DD'
              );
              let endDate = moment(
                `${tmpDateEnd.year}-${tmpDateEnd.month + 1}-${tmpDateEnd.day}`,
                'YYYY-MM-DD'
              );
              let targetDateIndex = 0;

              /*
                          if (taskCode.length < 8) {
                            taskCode = `${order.code}_${week}`
                            old = true
                          }
                          */

              // Recupero il code di tutti gli order visualizzati
              if (!this.orderCodes.includes(order.code))
                this.orderCodes.push(order.code);
              if (!this.orderIds.includes(order.id))
                this.orderIds.push(order.id);

              let name = order.subjectFullName;
              if (['', null, undefined].includes(name))
                name = order.nameAdminCondominius;

              if (!this.tasksCodeStructure[taskCode]) {
                this.tasksCodeStructure[taskCode] = {
                  teamLeaderIds: [],
                  assistantIds: [],
                  assistantNameList: [],
                  days: [],
                  orderCode: order.code,
                  orderId: order.id,
                  eventColor: task?.practice?.color,
                  notes: task?.note,
                  // eventColor: this.getAndSetOrderColor(order.code),   
                  clientName: name,
                  nameBuilding: `${order.nameBuilding} - ${order.city}`,
                  version: order.version,
                  weekCode: weekCode,
                  multipleCodeWeek: [],
                  old: old,
                  draggable: false,
                  resizable: false,
                  PassiveHoursTotal: order.PassiveHoursTotal,
                  OrderHoursTotal: order.OrderHoursTotal,
                  TaskHoursTotal: order.TaskHoursTotal,
                  valueSold: order.valueSold,
                  currentDownPaymentPercentage: order.currentDownPaymentPercentage,
                  activeControl: order.activeControl,
                  percentageStatus: order.percentageStatus,
                  firstStepPercentage: order.firstStepPercentage,
                  iconCls: ''
                };
              }

              while (
                this.getNextDay(startDate, targetDateIndex).isSameOrBefore(
                  endDate
                )
              ) {
                let curretTargetDate = this.getNextDay(
                  startDate,
                  targetDateIndex
                );

                let tmpCodeWeek = `${curretTargetDate.format(
                  'YYYY'
                )}_${curretTargetDate.format('WW')}`;
                if (
                  !this.tasksCodeStructure[taskCode].multipleCodeWeek.includes(
                    tmpCodeWeek
                  )
                )
                  this.tasksCodeStructure[taskCode].multipleCodeWeek.push(
                    tmpCodeWeek
                  );
                targetDateIndex += 1;
              }

              if (old) {
                this.tasksCodeStructure[taskCode].draggable = false;
                this.tasksCodeStructure[taskCode].resizable = false;
              }

              // se il task è di un assistente, lo aggiunge all'array e termina il ciclo
              if (task.userRoleId != 36) {
                if (
                  !this.tasksCodeStructure[taskCode].assistantIds.includes(
                    task.userId
                  )
                )
                  this.tasksCodeStructure[taskCode].assistantIds.push(
                    task.userId
                  );
                if (
                  !this.tasksCodeStructure[taskCode].assistantNameList.includes(
                    task.userName
                  )
                )
                  this.tasksCodeStructure[taskCode].assistantNameList.push(
                    task.userName
                  );
                return;
              }

              if (
                !this.tasksCodeStructure[taskCode].days.includes(task.tsStart)
              ) {
                this.tasksCodeStructure[taskCode].days.push(task.tsStart);
              }

              if (
                !this.tasksCodeStructure[taskCode].days.includes(task.tsEnd)
              ) {
                this.tasksCodeStructure[taskCode].days.push(task.tsEnd);
              }

              if (task.userRoleId == 36) {
                this.tasksCodeStructure[taskCode].teamLeaderIds.push(
                  task.userId
                );
              }

              if (!tmp_code[taskCode]) {
                tmp_code[taskCode] = [];
              }
              tmp_code[taskCode].push(task);
            });
          });

          //console.log(this.tasksCodeStructure)
          // WIP
          for (const [key, value] of Object.entries(this.tasksCodeStructure)) {

            //console.log(this.codeStructure[key].days)
            if (this.tasksCodeStructure[key].days.length != 0) {
              this.tasksCodeStructure[key].days.sort(function (x: any, y: any) {
                return x - y;
              });
              const tlIds: number[] = this.tasksCodeStructure[key].teamLeaderIds || [];
              const asRaw = this.tasksCodeStructure[key].assistants ?? this.tasksCodeStructure[key].assistantIds ?? [];
              const asIds: number[] = Array.isArray(asRaw) ? asRaw : [];
              const days: number[] = this.tasksCodeStructure[key].days || [];
              const hasAbs = this.hasAbsenceFor(days, [...tlIds, ...asIds]);
              const iconCls = this.iconFor(!this.tasksCodeStructure[key].percentageStatus, hasAbs);
              //console.log(key)
              console.log('this.tasksCodeStructure[key]', this.tasksCodeStructure[key])
              const segments = this.splitIntoContiguousDaySegments(this.tasksCodeStructure[key].days);

              segments.forEach((segmentDays, idx) => {
                const segId = `${key}#${idx + 1}`;
                const tmpEvent = {
                  id: segId,
                  groupId: key, // <-- NUOVO

                  startDate: this.getDateFromTimestamp(segmentDays[0]),
                  endDate: this.dayEndExclusive(segmentDays[segmentDays.length - 1]),
                  name: `${this.tasksCodeStructure[key].orderCode} - ${this.tasksCodeStructure[key].clientName} - ${this.tasksCodeStructure[key].nameBuilding}`,
                  code: this.tasksCodeStructure[key].orderCode,
                  orderId: this.tasksCodeStructure[key].orderId,
                  clientName: this.tasksCodeStructure[key].clientName,
                  nameBuilding: this.tasksCodeStructure[key].nameBuilding,
                  assistants: this.tasksCodeStructure[key].assistantIds,
                  assistantsName: this.tasksCodeStructure[key].assistantNameList,
                  eventColor: this.tasksCodeStructure[key].eventColor,
                  version: this.tasksCodeStructure[key].version,
                  finalBalancer: false,
                  weekCode: `${this.tasksCodeStructure[key].teamLeaderId}_${this.tasksCodeStructure[key].weekCode}`,
                  multipleCodeWeek: this.tasksCodeStructure[key].multipleCodeWeek.map(
                    (cw: any) => `${this.tasksCodeStructure[key].orderCode}_${cw}`
                  ),
                  days: segmentDays,
                  prio: 'high',
                  draggable: this.tasksCodeStructure[key].draggable,
                  resizable: this.tasksCodeStructure[key].resizable,
                  old: this.tasksCodeStructure[key].old,
                  PassiveHoursTotal: this.tasksCodeStructure[key].PassiveHoursTotal,
                  OrderHoursTotal: this.tasksCodeStructure[key].OrderHoursTotal,
                  TaskHoursTotal: this.tasksCodeStructure[key].TaskHoursTotal,
                  valueSold: this.tasksCodeStructure[key].valueSold,
                  currentDownPaymentPercentage: this.tasksCodeStructure[key].currentDownPaymentPercentage,
                  activeControl: this.tasksCodeStructure[key].activeControl,
                  percentageStatus: this.tasksCodeStructure[key].percentageStatus,
                  firstStepPercentage: this.tasksCodeStructure[key].firstStepPercentage,
                  iconCls,
                  notes: this.tasksCodeStructure[key].notes
                };

                this.tasksEvents.push(tmpEvent);
                this.tasksAssignments.push({
                  event: segId,
                  resource: this.tasksCodeStructure[key].orderId,
                });
              });

            }
          }
          //console.log(this.tasksEvents)
          //console.log(this.tasksAssignments)
        }

        this.codeStructureUnion();
        if (loading) this.libService.unlockPage();
        this.loadFinalBalancersForOrders();
      });
  }

  loadFinalBalancersForOrders(loading: any = false) {
    // CONSUNTIVAZIONE
    console.log('LOAD LOAD FINAL BALANCERS FOR ORDERS');
    if (loading) this.libService.lockPage('');
    let currentUser = this.userSessionService.getState('user');

    // Reset Variabili
    this.finalBalancesCodeStructure = {};
    this.finalBalancesEvents = [];
    this.finalBalancesAssignments = [];

    this.tasksWithFinalBalancesEvents = [];
    this.tasksWithFinalBalancesAssignments = [];

    this.seedMetricsFromRawTasks();
    console.log('seeded base metrics', Array.from(this.metricsByOrderId.entries()).slice(0, 3));

    let testDays: any = {};

    this.planningService
      .getFinalBalancers(currentUser.email, this.orderIds)
      .subscribe((finalBalancers: any) => {
        let tmp_code: any = {};

        finalBalancers.forEach((finalBalancer: any) => {
          //console.log(tmpTask)
          //console.log(finalBalancer)

          Object.entries(finalBalancer.teams).forEach((entry) => {
            const [key, value]: any = entry;

            //console.log(key)
            if (![undefined, null].includes(key)) {
              Object.entries(value.ts).forEach((final) => {
                const [keyFinal, valueFinal]: any = final;
                let tmpDays = valueFinal.days;
                //console.log(tmpDays)

                let uniqCode = `${finalBalancer.code}_${keyFinal}`;
                let code = `${key}_${keyFinal}_${finalBalancer.code}`;
                //console.log('CODE')
                //console.log(code)

                let clientName = finalBalancer.idSubject
                  ? finalBalancer.subjectFullName
                  : finalBalancer.nameAdminCondominius;

                if (!this.finalBalancesCodeStructure[code]) {
                  this.finalBalancesCodeStructure[code] = {
                    teamLeaderId: key,
                    uniqCode: uniqCode,
                    assistantIds: [],
                    days: [],
                    orderCode: finalBalancer.code,
                    orderId: finalBalancer.orderId,
                    eventColor: 'gray',
                    clientName: clientName,
                    nameBuilding: `${finalBalancer.nameBuilding} - ${finalBalancer.city}`,
                    version: finalBalancer.version,
                    deliberateQuantityToBeProduced:
                      finalBalancer.deliberateQuantityToBeProduced,
                    teamLeaderSAL: value.totalQtSal,
                    weekSAL: valueFinal.totalQtSal,
                    totalSAL: finalBalancer.totalQtSal,
                    qtOreManodopera: finalBalancer.qtOreManodopera,
                    deliberateValueToBeProduced:
                      finalBalancer.deliberateValueToBeProduced,
                    totalSALValue: finalBalancer.totalValoreSal,
                    weekSALValue: valueFinal.totalValoreSal,
                    finalBalanceHours: finalBalancer.finalBalanceHours,
                    PassiveHoursTotal: finalBalancer.PassiveHoursTotal,
                    OrderHoursTotal: finalBalancer.OrderHoursTotal,
                    TaskHoursTotal: finalBalancer.TaskHoursTotal,
                    valueSold: finalBalancer.valueSold,
                    currentDownPaymentPercentage: finalBalancer.currentDownPaymentPercentage,
                    activeControl: finalBalancer.activeControl,
                    percentageStatus: finalBalancer.percentageStatus,
                    firstStepPercentage: finalBalancer.firstStepPercentage,
                    iconCls: ''
                  };
                }
                this.finalBalancesCodeStructure[code].days = [
                  ...this.finalBalancesCodeStructure[code].days,
                  ...tmpDays,
                ];
              });
            }
          });
        });

        Object.entries(this.finalBalancesCodeStructure).forEach(
          (structurefinalBalance) => {
            const [keyStructure, valueStructure]: any = structurefinalBalance;

            let currentDays = valueStructure.days.sort(function (
              x: any,
              y: any
            ) {
              return x - y;
            });

            let percentDoneTotal = Math.round(
              (valueStructure.totalSAL /
                valueStructure.deliberateQuantityToBeProduced) *
              100
            );
            let percentDoneTeamLeader = Math.round(
              (valueStructure.teamLeaderSAL /
                valueStructure.deliberateQuantityToBeProduced) *
              100
            );
            let percentDoneWeek = Math.round(
              (valueStructure.weekSAL /
                valueStructure.deliberateQuantityToBeProduced) *
              100
            );

            let totalSALValuePercent = Math.round(
              (valueStructure.totalSALValue /
                valueStructure.deliberateValueToBeProduced) *
              100
            );
            let weekSALValuePercent = Math.round(
              (valueStructure.weekSALValue /
                valueStructure.deliberateValueToBeProduced) *
              100
            );
            const tlIds: number[] = [Number(valueStructure.teamLeaderId)].filter(n => !Number.isNaN(n));
            const asRaw = valueStructure.assistants ?? valueStructure.assistantIds ?? []; // se in futuro li aggiungi
            const asIds: number[] = Array.isArray(asRaw) ? asRaw : [];
            const hasAbs = this.hasAbsenceFor(currentDays, [...tlIds, ...asIds]);
            const iconCls = this.iconFor(!valueStructure.percentageStatus, hasAbs);

            if (!testDays[keyStructure])
              testDays[keyStructure] = currentDays.map((day: any) =>
                this.getDateFromTimestamp(day)
              );

            let finalBalanceObject = {
              name: `${percentDoneTotal}% - ${valueStructure.orderCode} - ${valueStructure.clientName} - ${valueStructure.nameBuilding}`,
              uniqCode: valueStructure.uniqCode,
              deliberateQuantityToBeProduced:
                valueStructure.deliberateQuantityToBeProduced.toFixed(2),
              deliberateValueToBeProduced:
                valueStructure.deliberateValueToBeProduced.toFixed(2),
              orderId: valueStructure.orderId,
              totalSAL: valueStructure.totalSAL.toFixed(2),
              teamLeaderSAL: valueStructure.teamLeaderSAL.toFixed(2),
              teamLeaderSALpercent: percentDoneTeamLeader,
              weekSAL: valueStructure.weekSAL.toFixed(2),
              weekSALpercent: percentDoneWeek,
              totalSALValue: valueStructure.totalSALValue.toFixed(2),
              totalSALValuePercent: totalSALValuePercent,
              weekSALValue: valueStructure.weekSALValue.toFixed(2),
              weekSALValuePercent: weekSALValuePercent,
              percentDone: percentDoneTotal,
              qtOreManodopera: valueStructure.qtOreManodopera.toFixed(2),
              finalBalanceHours: valueStructure.finalBalanceHours,
              weekCode: keyStructure,
              PassiveHoursTotal: valueStructure.PassiveHoursTotal,
              OrderHoursTotal: valueStructure.OrderHoursTotal,
              TaskHoursTotal: valueStructure.TaskHoursTotal,
              valueSold: valueStructure.valueSold,
              currentDownPaymentPercentage: valueStructure.currentDownPaymentPercentage,
              activeControl: valueStructure.activeControl,
              percentageStatus: valueStructure.percentageStatus,
              firstStepPercentage: valueStructure.firstStepPercentage,
              currentDays: currentDays,
              weekDays: currentDays.map((day: any) =>
                moment.unix(day).format('dd')
              ),
              alreadyProcessed: false,
              iconCls
            };
            const oid = valueStructure.orderId;
            const m = this.metricsByOrderId.get(oid) || {};
            m.totalValoreSal = Number(valueStructure.totalSALValue);                 // totale valore SAL
            m.deliberateValueToBeProduced = Number(valueStructure.deliberateValueToBeProduced);
            this.computeDerivedMetrics(m);                                           // calcola tutte le % e MLC/MediaLorda
            this.metricsByOrderId.set(oid, m);
            //console.log(keyStructure)
            //console.log(valueStructure.uniqCode)
            const tmpTaskToChange = this.tasksWithFinalBalancesEvents.findIndex(
              (task: any) => {
                return task.multipleCodeWeek.includes(valueStructure.uniqCode);
              }
            );
            //console.log(tmpTaskToChange)

            const taskToChange = this.tasksEvents.findIndex((task: any) => {
              return task.multipleCodeWeek.includes(valueStructure.uniqCode);
            });
            //console.log(taskToChange)

            if (tmpTaskToChange != -1) {
              // Casistica in cui è già stata fatta un primo aggangio del consuntivo

              this.tasksWithFinalBalancesEvents[tmpTaskToChange].weekSAL =
                parseInt(
                  this.tasksWithFinalBalancesEvents[tmpTaskToChange].weekSAL
                ) + parseInt(finalBalanceObject.weekSAL);
              this.tasksWithFinalBalancesEvents[tmpTaskToChange].weekSALValue =
                parseInt(
                  this.tasksWithFinalBalancesEvents[tmpTaskToChange]
                    .weekSALValue
                ) + parseInt(finalBalanceObject.weekSALValue);

              this.tasksWithFinalBalancesEvents[
                tmpTaskToChange
              ].weekSALpercent = Math.round(
                (this.tasksWithFinalBalancesEvents[tmpTaskToChange].weekSAL /
                  valueStructure.deliberateQuantityToBeProduced) *
                100
              );
              this.tasksWithFinalBalancesEvents[
                tmpTaskToChange
              ].weekSALValuePercent = Math.round(
                (this.tasksWithFinalBalancesEvents[tmpTaskToChange]
                  .weekSALValue /
                  valueStructure.deliberateValueToBeProduced) *
                100
              );

              this.tasksWithFinalBalancesEvents[tmpTaskToChange].weekDays = [
                ...this.tasksWithFinalBalancesEvents[tmpTaskToChange].weekDays,
                ...finalBalanceObject.weekDays,
              ];
              const m = this.metricsByOrderId.get(valueStructure.orderId);
              if (m) this.stampMetrics(this.tasksWithFinalBalancesEvents[tmpTaskToChange], m);

            } else if (taskToChange != -1) {
              // Casistica in cui è la prima volta in cui viene fatto un aggancio di consuntivo
              let tmpTasksWithFinalBalances = Object.assign(
                {},
                this.tasksEvents[taskToChange]
              );

              tmpTasksWithFinalBalances.withFinalBalancer = true;
              Object.entries(finalBalanceObject).forEach((object) => {
                const [keyObject, valueObject]: any = object;
                tmpTasksWithFinalBalances[keyObject] = valueObject;
              });
              const m = this.metricsByOrderId.get(valueStructure.orderId);
              if (m) this.stampMetrics(tmpTasksWithFinalBalances, m);

              tmpTasksWithFinalBalances.finalBalancer = false;
              this.tasksWithFinalBalancesEvents.push(tmpTasksWithFinalBalances);

              this.tasksWithFinalBalancesAssignments.push({
                event: tmpTasksWithFinalBalances.id,
                resource: valueStructure.orderId,
              });
            } else {
              // Casistica in cui non esiste un evento a cui agganciare il consuntivo

              let lastIndex = currentDays.length - 1;
              if (currentDays.length == 1) lastIndex = 0;

              //console.log(keyStructure)
              //console.log(valueStructure.orderCode)
              //console.log(currentDays)
              //console.log(currentDays.map((cd: any) => this.getDateFromTimestamp(cd)))
              //console.log(this.getDateFromTimestampWithHourNotUTC(currentDays[0], true))
              //console.log(this.getDateFromTimestampWithHourNotUTC(currentDays[lastIndex], false))

              // SAL TEAM LEADER
              let tmpEvent: any = {
                id: keyStructure,
                startDate: this.getDateFromTimestampWithHourNotUTC(
                  currentDays[0],
                  true
                ),
                endDate: this.getDateFromTimestampWithHourNotUTC(
                  currentDays[lastIndex],
                  false
                ),
                name: `${percentDoneTotal}% - ${valueStructure.orderCode} - ${valueStructure.clientName} - ${valueStructure.nameBuilding}`,
                code: valueStructure.orderCode,
                clientName: valueStructure.clientName,
                nameBuilding: valueStructure.nameBuilding,
                assistants: '',
                eventColor: 'gray',
                draggable: false,
                resizable: false,
                finalBalancer: true,
                prio: 'high',
              };

              Object.entries(finalBalanceObject).forEach((object) => {
                const [keyObject, valueObject]: any = object;
                tmpEvent[keyObject] = valueObject;
              });
              const m = this.metricsByOrderId.get(valueStructure.orderId);
              if (m) this.stampMetrics(tmpEvent, m);

              this.finalBalancesEvents.push(tmpEvent);

              this.finalBalancesAssignments.push({
                event: keyStructure,
                resource: valueStructure.orderId,
              });
            }
          }
        );

        this.codeStructureUnion();
        for (const ev of this.tasksEvents) {
          const m = this.metricsByOrderId.get(ev.orderId);
          if (!m) continue;
          this.stampMetrics(ev, m);   // quando m esiste già

        }
      });
  }

  getCurrentWeekNumber() {
    let today = new Date();
    let structure = {
      year: today.getUTCFullYear(),
      month: today.getUTCMonth(),
      day: today.getUTCDate(),
    };
    let week = moment(
      `${structure.year}-${structure.month + 1}-${structure.day}`,
      'YYYY-MM-DD'
    ).format('WW');
    return week;
  }

  loadTasks(loading: any = false) {
    console.log('LOAD TASKS');
    if (loading) this.libService.lockPage('');
    let currentUser = this.userSessionService.getState('user');

    this.resetFilterByName();

    // Reset Variabili
    this.tasksCodeStructure = {};
    this.tasksEvents = [];
    this.tasksAssignments = [];

    let teamWithTheScheduleForTheCurrentWeek: any = [];
    console.log(this.plannerType);
    const manageData = (tasks: any) => {
      this.rawTasks = tasks;
      let tmp_code: any = {};
      console.log(tasks);


      this.metricsByOrderId.clear();

      tasks.forEach((task: any) => {
        let order = task.Order;
        const oid = order?.id;
        if (oid) {
          const m = this.metricsByOrderId.get(oid) || {};
          m.valueSold = task.valueSold ?? m.valueSold ?? 0;
          m.fatturato = task.fatturato ?? m.fatturato ?? 0;
          m.incassato = task.incassato ?? m.incassato ?? 0;
          m.valoreMateriali = task.ValoreMateriali ?? m.valoreMateriali ?? 0;
          m.valoreStorni = task.ValoreStorni ?? m.valoreStorni ?? 0;
          m.valoreOreMlc = task.valoreOreMlc ?? m.valoreOreMlc ?? 0;
          m.valoreStorniDelibera = task.ValoreStorniDelibera ?? m.valoreStorniDelibera ?? 0;   // 👈 NEW
          this.metricsByOrderId.set(oid, m);
        }
        let taskCode = task.code;

        let orderCode = task?.mainCode || order.code;
        let tmpDate = this.getDateFromTimestampInPieces(task.tsStart);
        let tmpDateEnd = this.getDateFromTimestampInPieces(task.tsEnd);
        let week = moment(
          `${tmpDate.year}-${tmpDate.month + 1}-${tmpDate.day}`,
          'YYYY-MM-DD'
        ).format('WW');
        let weekCode = `${tmpDate.year}_${week}`;
        let old = false;

        let startDate = moment(
          `${tmpDate.year}-${tmpDate.month + 1}-${tmpDate.day}`,
          'YYYY-MM-DD'
        );
        let endDate = moment(
          `${tmpDateEnd.year}-${tmpDateEnd.month + 1}-${tmpDateEnd.day}`,
          'YYYY-MM-DD'
        );
        let targetDateIndex = 0;

        if (taskCode.length < 8) {
          taskCode = `${orderCode}_${week}`;
          old = true;
        }

        if (task.code.length > 8) {
          // Recupero il code di tutti gli order visualizzati
          if (!this.orderCodes.includes(orderCode))
            this.orderCodes.push(orderCode);
          if (!this.orderIds.includes(order.id)) this.orderIds.push(order.id);

          let name = order.subjectFullName;
          if (['', null, undefined].includes(name))
            name = order.nameAdminCondominius;

          if (!this.tasksCodeStructure[taskCode]) {
            this.tasksCodeStructure[taskCode] = {
              teamLeaderId: null,
              assistantIds: [],
              assistantNameList: [],
              days: [],
              orderCode: orderCode,
              orderId: order.id,
              eventColor: task?.practice?.color ? task?.practice?.color : this.defaultColor,
              color: task?.practice?.color ? task?.practice?.color : this.defaultColor,
              clientName: name,
              nameBuilding: `${order.nameBuilding} - ${order.city}`,
              version: order.version,
              weekCode: weekCode,
              multipleCodeWeek: [],
              old: old,
              PassiveHoursTotal: task.PassiveHoursTotal,
              OrderHoursTotal: task.OrderHoursTotal,
              TaskHoursTotal: task.TaskHoursTotal,
              valueSold: task.valueSold,
              currentDownPaymentPercentage: task.currentDownPaymentPercentage,
              activeControl: task.activeControl,
              percentageStatus: task.percentageStatus,
              firstStepPercentage: task.firstStepPercentage,
              week: week,
              currentWeek: this.getCurrentWeekNumber(),
              iconCls: '',
              notes: task?.note,
            };

            if (task.officeId === this.getCompany()) {
              this.tasksCodeStructure[taskCode].draggable = true;
              this.tasksCodeStructure[taskCode].resizable = true;
            } else {
              this.tasksCodeStructure[taskCode].draggable = false;
              this.tasksCodeStructure[taskCode].resizable = false;
            }
          }

          while (
            this.getNextDay(startDate, targetDateIndex).isSameOrBefore(endDate)
          ) {
            let curretTargetDate = this.getNextDay(startDate, targetDateIndex);

            let tmpCodeWeek = `${curretTargetDate.format(
              'YYYY'
            )}_${curretTargetDate.format('WW')}`;
            if (
              !this.tasksCodeStructure[taskCode].multipleCodeWeek.includes(
                tmpCodeWeek
              )
            )
              this.tasksCodeStructure[taskCode].multipleCodeWeek.push(
                tmpCodeWeek
              );
            targetDateIndex += 1;
          }

          if (old) {
            this.tasksCodeStructure[taskCode].draggable = false;
            this.tasksCodeStructure[taskCode].resizable = false;
          }

          // se il task è di un assistente, lo aggiunge all'array e termina il ciclo
          if (task.userRoleId != 36 && task.userRoleId != UserRole.ENERGY) {
            if (
              !this.tasksCodeStructure[taskCode].assistantIds.includes(
                task.userId
              )
            )
              this.tasksCodeStructure[taskCode].assistantIds.push(task.userId);
            if (
              !this.tasksCodeStructure[taskCode].assistantNameList.includes(
                task.userName
              )
            )
              this.tasksCodeStructure[taskCode].assistantNameList.push(
                task.userName
              );
            return;
          }

          if (!this.tasksCodeStructure[taskCode].days.includes(task.tsStart)) {
            this.tasksCodeStructure[taskCode].days.push(task.tsStart);
          }

          if (!this.tasksCodeStructure[taskCode].days.includes(task.tsEnd)) {
            this.tasksCodeStructure[taskCode].days.push(task.tsEnd);
          }

          if (task.userRoleId == 36 || task.userRoleId == UserRole.ENERGY) {
            this.tasksCodeStructure[taskCode].teamLeaderId = task.userId;
          }
        }

        if (!tmp_code[taskCode]) {
          tmp_code[taskCode] = [];
        }
        tmp_code[taskCode].push(task);
      });

      console.log(this.tasksCodeStructure);
      // WIP
      for (const [key, value] of Object.entries(this.tasksCodeStructure)) {
        //console.log(this.codeStructure[key].days)
        if (this.tasksCodeStructure[key].days.length != 0) {
          this.tasksCodeStructure[key].days.sort(function (x: any, y: any) {
            return x - y;
          });
          // --- ABSENCE CHECK: TL + assistants ---
          const teamLeaderId = this.tasksCodeStructure[key].teamLeaderId;

          // accetta sia .assistantIds che .assistants
          const assistantIdsRaw =
            this.tasksCodeStructure[key].assistants ?? this.tasksCodeStructure[key].assistantIds ?? [];

          const assistantIds: number[] = Array.isArray(assistantIdsRaw) ? assistantIdsRaw : [];

          const eventDaysYMD = (this.tasksCodeStructure[key].days as number[])
            .map(ts => this.unixToYMD(ts));

          const participants = [...new Set([teamLeaderId, ...assistantIds])]
            .filter((v): v is number => typeof v === 'number' && !Number.isNaN(v));

          const hasAbsenceAny = participants.some(uid => {
            const set: Set<string> = this.absencesByUser[String(uid)] ?? new Set<string>();
            return eventDaysYMD.some(d => set.has(d));
          });

          const hasnotCashflow = !this.tasksCodeStructure[key].percentageStatus;

          const iconCls = this.pickIconCls(hasnotCashflow, hasAbsenceAny);

          console.log('structure', this.tasksCodeStructure[key]);
          const allDays: number[] = this.tasksCodeStructure[key].days;
          const segments = this.splitIntoContiguousDaySegments(allDays);

          segments.forEach((segmentDays, idx) => {
            const segId = `${key}#${idx + 1}`;
            const startDate = this.atLocalHour(segmentDays[0], 9, 0);
            const endDate = this.atLocalHour(segmentDays[segmentDays.length - 1], 18, 0);


            const tmpEvent = {
              id: segId,                 // id univoco per Bryntum
              groupId: key,              // <-- NUOVO: id logico per backend

              startDate,
              endDate,
              name: `${this.tasksCodeStructure[key].orderCode} - ${this.tasksCodeStructure[key].clientName} - ${this.tasksCodeStructure[key].nameBuilding}`,
              code: this.tasksCodeStructure[key].orderCode,
              orderId: this.tasksCodeStructure[key].orderId,
              clientName: this.tasksCodeStructure[key].clientName,
              nameBuilding: this.tasksCodeStructure[key].nameBuilding,
              assistants: this.tasksCodeStructure[key].assistantIds,
              assistantsName: this.tasksCodeStructure[key].assistantNameList,
              eventColor: this.tasksCodeStructure[key].eventColor,
              color: this.tasksCodeStructure[key].eventColor,
              documentCompositions: this.tasksCodeStructure[key].documentCompositions || [],
              fatturato: this.tasksCodeStructure[key].fatturato,
              incassato: this.tasksCodeStructure[key].incassato,
              version: this.tasksCodeStructure[key].version,
              finalBalancer: false,
              weekCode: `${this.tasksCodeStructure[key].teamLeaderId}_${this.tasksCodeStructure[key].weekCode}`,
              multipleCodeWeek: this.tasksCodeStructure[key].multipleCodeWeek.map(
                (cw: any) => `${this.tasksCodeStructure[key].teamLeaderId}_${cw}_${this.tasksCodeStructure[key].orderCode}`
              ),
              days: segmentDays, // <-- solo i giorni del segmento
              prio: 'high',
              draggable: this.tasksCodeStructure[key].draggable,
              resizable: this.tasksCodeStructure[key].resizable,
              old: this.tasksCodeStructure[key].old,
              PassiveHoursTotal: this.tasksCodeStructure[key].PassiveHoursTotal,
              OrderHoursTotal: this.tasksCodeStructure[key].OrderHoursTotal,
              TaskHoursTotal: this.tasksCodeStructure[key].TaskHoursTotal,
              valueSold: this.tasksCodeStructure[key].valueSold,
              currentDownPaymentPercentage: this.tasksCodeStructure[key].currentDownPaymentPercentage,
              teamLeaderId: this.tasksCodeStructure[key].teamLeaderId,
              week: this.tasksCodeStructure[key].week,
              currentWeek: this.tasksCodeStructure[key].currentWeek,
              activeControl: this.tasksCodeStructure[key].activeControl,
              percentageStatus: this.tasksCodeStructure[key].percentageStatus,
              firstStepPercentage: this.tasksCodeStructure[key].firstStepPercentage,
              iconCls,
              notes: this.tasksCodeStructure[key].notes
            };

            // metriche base già tue
            const baseM = this.metricsByOrderId.get(this.tasksCodeStructure[key].orderId);
            if (baseM) {
              Object.assign(tmpEvent, {
                ValoreFatturato: baseM.fatturato ?? null,
                ValoreIncassato: baseM.incassato ?? null,
                PercIncMDO: baseM.PercIncMDO ?? null,
                valueSold: baseM.valueSold ?? null,
                ValoreMateriali: baseM.valoreMateriali ?? null,
                ValoreStorni: baseM.valoreStorni ?? null,
                valoreOreMlc: baseM.valoreOreMlc ?? null
              });
            }

            this.tasksEvents.push(tmpEvent);
            this.tasksAssignments.push({
              event: segId,
              resource: this.tasksCodeStructure[key].teamLeaderId,
            });
          });


        }
      }
      console.log(this.tasksEvents);
      console.log(this.tasksAssignments);
      this.orderIds = Array.from(
        new Set((this.rawTasks || [])
          .map((t: any) => t?.Order?.id)
          .filter((id: any) => Number.isFinite(id)))
      );

      // chiave che rappresenta richiesta corrente (ordini + intervallo)
      const fbKey = JSON.stringify({
        ids: [...this.orderIds].sort((a, b) => a - b),
        start: this.planningStartDate?.toISOString?.() ?? null,
        end: this.planningEndDate?.toISOString?.() ?? null
      });

      if (this.orderIds.length > 0 && !this.finalBalancersInFlight && fbKey !== this.lastFinalBalancersKey) {
        this.lastFinalBalancersKey = fbKey;
        this.finalBalancersInFlight = true;
        this.loadFinalBalancers(false);
      }


      // Ordina la lista dei capo cantieri in base alle commesse pianificate nella settimana corrente
      this.schedulerPro.resourceStore.sort((a: any, b: any) => {
        return (
          teamWithTheScheduleForTheCurrentWeek.includes(b.id) -
          teamWithTheScheduleForTheCurrentWeek.includes(a.id)
        );
      });

      //console.log(this.tasksEvents)
      //console.log(this.tasksAssignments)
      this.codeStructureUnion();

      this.rebuildAbsenceDayMarkers();
      if (loading) this.libService.unlockPage();

      //console.log(this.orderCodes)


      // this.loadFinalBalancers();


      //console.log(tmp_code)
      //console.log(this.events)
      //console.log(this.codeStructure)
    };

    if (this.plannerType === 'core') {
      this.planningService
        .getOrdersAndTasksWithPagination(this.getCompany(), this.planningStartDate, this.planningEndDate)
        .pipe(
          switchMap((tasks: any) => this.fetchAbsencesForRange().pipe(map(() => tasks)))
        )
        .subscribe((tasks: any) => {
          manageData(tasks);
          this.operatorPlanningSummary = tasks;
        });
    } else if (this.plannerType === 'energy') {
      this.planningService
        .getOrdersAndTasksEnergyWithPagination(this.getCompany(), this.planningStartDate, this.planningEndDate)
        .pipe(
          switchMap((tasks: any) => this.fetchAbsencesForRange().pipe(map(() => tasks)))
        )
        .subscribe((tasks: any) => {
          manageData(tasks);
          this.operatorPlanningSummary = tasks;
        });
    }


  }


  /** unione senza duplicati */
  private union<T>(a: T[] = [], b: T[] = []): T[] {
    const set = new Set([...(a ?? []), ...(b ?? [])]);
    return Array.from(set);
  }

  /** applica/accumula i dati di consuntivo su un event esistente */
  private applyFinalBalanceToTask(ev: any, fb: any, totals: { deliberateQty: number; deliberateVal: number }) {
    // prima volta: inizializza
    if (!ev.withFinalBalancer) {
      ev.withFinalBalancer = true;

      ev.deliberateQuantityToBeProduced = Number(fb.deliberateQuantityToBeProduced);
      ev.deliberateValueToBeProduced = Number(fb.deliberateValueToBeProduced);

      ev.totalSAL = Number(fb.totalSAL);
      ev.teamLeaderSAL = Number(fb.teamLeaderSAL);
      ev.weekSAL = Number(fb.weekSAL);

      ev.totalSALValue = Number(fb.totalSALValue);
      ev.weekSALValue = Number(fb.weekSALValue);

      ev.percentDone = Number(fb.percentDone);
      ev.teamLeaderSALpercent = Number(fb.teamLeaderSALpercent);
      ev.weekSALpercent = Number(fb.weekSALpercent);
      ev.totalSALValuePercent = Number(fb.totalSALValuePercent);
      ev.weekSALValuePercent = Number(fb.weekSALValuePercent);

      ev.qtOreManodopera = Number(fb.qtOreManodopera);
      ev.finalBalanceHours = fb.finalBalanceHours;

      ev.weekDays = Array.isArray(fb.weekDays) ? [...fb.weekDays] : [];
      ev.finalBalancerDays = fb.finalBalancerDays ?? [];

    } else {
      // accumula su valori già presenti
      ev.weekSAL = Number(ev.weekSAL ?? 0) + Number(fb.weekSAL);
      ev.weekSALValue = Number(ev.weekSALValue ?? 0) + Number(fb.weekSALValue);

      // unisci giorni / weekDays
      ev.weekDays = this.union(ev.weekDays, fb.weekDays);
      ev.finalBalancerDays = this.union(ev.finalBalancerDays, fb.finalBalancerDays);
    }

    // ricalcola percentuali “week” basandosi sui totali deliberati (stabili per ordine)
    const dq = Number(totals.deliberateQty || ev.deliberateQuantityToBeProduced || 0);
    const dv = Number(totals.deliberateVal || ev.deliberateValueToBeProduced || 0);

    if (dq > 0) ev.weekSALpercent = Math.round((Number(ev.weekSAL || 0) / dq) * 100);
    if (dv > 0) ev.weekSALValuePercent = Math.round((Number(ev.weekSALValue || 0) / dv) * 100);
  }

  generateOperatorPlanningSummary(response: any[], startDate: Date, endDate: Date) {
    // console.log('response: ', response);
    // Convert startDate and endDate to timestamps
    const startTimestamp = startDate.getTime() / 1000; // Convert to seconds
    const endTimestamp = endDate.getTime() / 1000; // Convert to seconds

    // Initialize the structure
    let operatorPlanningSummary: { [key: string]: any } = {};

    // Iterate over the response
    response.forEach((item) => {
      const tsStart = parseInt(item.tsStart, 10);
      const tsEnd = parseInt(item.tsEnd, 10);

      // Filter the items based on startDate and endDate
      if (tsStart >= startTimestamp && tsEnd <= endTimestamp) {
        // Calculate hours worked based on tsStart and tsEnd
        const workedHours = (tsEnd - tsStart) / 3600; // Convert from seconds to hours

        // Convert the timestamp to 'gg/mm/yyyy' format
        const date = new Date(tsStart * 1000); // Convert to milliseconds
        const dateKey = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;

        // If the date key does not exist, initialize it
        if (!operatorPlanningSummary[dateKey]) {
          operatorPlanningSummary[dateKey] = {
            commesse: [],
          };
        }

        // Determine the role based on userRoleId
        let role = '';
        if (item.userRoleId === 35) {
          role = 'Operaio Assistente';
        } else if (item.userRoleId === 36) {
          role = 'Operaio Capo Squadra';
        }

        // Create the operator object with name, role, and worked hours
        const operator = {
          id: item.userId,
          name: item.userName.trim(),
          role: role,
          hours: workedHours // Use the calculated worked hours
        };

        // Find the commessa in the commesse array
        let commessa = operatorPlanningSummary[dateKey].commesse.find(
          (comm: any) => comm.code === item.Order.code
        );

        // If the commessa does not exist, create it
        if (!commessa) {
          commessa = {
            code: item.Order.code,
            building: item.Order.nameBuilding,
            city: item.Order.city,
            operators: []
          };
          operatorPlanningSummary[dateKey].commesse.push(commessa);
        }

        // Check if the operator is already in the commessa
        let existingOperator = commessa.operators.find(
          (op: any) => op.name === operator.name && op.role === operator.role
        );

        // If the operator exists, add the worked hours to the existing operator
        if (existingOperator) {
          existingOperator.hours += operator.hours;
        } else {
          // Add the new operator with the initial hours
          commessa.operators.push(operator);
        }
      }
    });

    return operatorPlanningSummary;
  }










  setStartDate({ value, userAction }: any) {
    if (userAction) {
      console.log(value)
      this.planningStartDate = value
      this.loadTasks(true);
    }

  }

  setEndDate({ value, userAction }: any) {
    if (userAction) {
      let endDate: any = moment(value).utc(true).hours(23).minutes(59).seconds(59).milliseconds(59).toDate()
      this.planningEndDate = endDate
      this.loadTasks(true);
    }
  }

  ngOnInit(): void {
    this.initLoadTasks();

  }

  // getRandomColor() {

  //   // return this.colorList[Math.floor(Math.random() * this.colorList.length)];
  //   const colors = Object.values(this.colorList);
  //   return colors[Math.floor(Math.random() * colors.length)];
  // }

  getResources() {
    if (this.plannerType === 'core') {
      this.financeGetRisorse('35,36'); // Assistants
    } else if (['energy', 'energyOperators'].includes(this.plannerType)) {
      this.financeGetRisorse(UserRole.ENERGY); // Assistants
    }
    this.financeGetRisorse(36); // TeamLeaders
  }

  getCompany() {
    const company = this.userSessionService.getState('working_company');
    if (!(company == null) && !(company.name == '*')) {
      return company.id;
    } else return 0;
  }

  financeGetRisorse(idRole: any) {
    let currentUser = this.userSessionService.getState('user');
    this.financeService
      .getRisorse(currentUser.email, this.getCompany(), idRole)
      .subscribe({
        next: (res: any) => {
          if (res.esito == 'OK') {
            if (this.plannerType === 'core') this.upsertResources(res?.item?.Table || []); // NEW
            this.schedulerPro = this.schedulerProComponent.instance;
            const editor = this.schedulerPro.features.eventEdit.editor;
            switch (idRole) {
              case UserRole.ASSISTANCE:
                this.assistants = res.item.Table;
                //editor.widgetMap['assistantsField'].items = this.assistants.map((a:any) => ({ text: a.name, value: a.id }));
                this.assistants.forEach((assistant: any) => {
                  this.assistantOptions.push({
                    id: assistant.id,
                    name: assistant.name,
                  });
                });
                break;
              case UserRole.TEAMLEADER:
                this.teamLeaders = res.item.Table;
                this.schedulerPro.resourceStore.removeAll();
                this.teamLeaders.forEach((team: any) => {
                  this.schedulerPro.resourceStore.add({
                    id: team.id,
                    name: team.name,
                  });
                });
                this.rebuildAbsenceDayMarkers();
                this.kickOrderingLikeSearch();
                break;
              case '35,36':
                res.item.Table.forEach((user: any) => {
                  let tmpUser = user;
                  this.resourcesList.push({ ...user });
                  tmpUser.idRuolo = 35;
                  this.assistants.push(tmpUser);
                });

                //editor.widgetMap['assistantsField'].items = this.assistants.map((a:any) => ({ text: a.name, value: a.id }));
                this.assistants.forEach((assistant: any) => {
                  this.assistantOptions.push({
                    id: assistant.id,
                    name: assistant.name,
                  });
                });
                break;
              case UserRole.ENERGY:
                break;
            }
          }
        },
        error: (e: any) => {
          console.log(e);
          this.teamLeaders = [];
        },
      });
  }
  private upsertResources(rows: any[]) {
    if (this.plannerType !== 'core') return; // SOLO core

    for (const r of (rows || [])) {
      const id = Number(r.id);
      const prev = this.allResourcesById.get(id);
      // priorità al ruolo "Operaio Capo Squadra" se esiste già
      const ruolo = (prev?.ruolo === 'Operaio Capo Squadra')
        ? prev.ruolo
        : (r.ruolo ?? prev?.ruolo ?? '');

      const NomeSede = r.NomeSede ?? prev?.NomeSede ?? null;

      this.allResourcesById.set(id, {
        id,
        name: r.name ?? '',
        ruolo,
        NomeSede
      });
    }
  }

  /** Raccoglie tutti gli ID risorsa pianificati nell’intervallo corrente
   *  unendo:
   *  - i task grezzi di getOrdersAndTaskWithPagination (this.rawTasks)
   *  - quanto hai aggregato in this.tasksCodeStructure (teamLeader + assistants)
   */
  private collectPlannedIdsFromTasks(): Set<number> {
    const planned = new Set<number>();

    // 1) dai task grezzi (API)
    for (const t of (this.rawTasks || [])) {
      const uid = Number(t?.userId);
      if (!uid) continue;

      // SOLO CORE: consideriamo ruoli 35 e 36 (in alcuni ambienti i label/ID possono invertire)
      if (this.plannerType === 'core') {
        if (t.userRoleId === 35 || t.userRoleId === 36) planned.add(uid);
        // fallback robusto: se manca userRoleId ma la stringa ruolo contiene "Operaio"
        if ((t.userRoleId == null || t.userRoleId === undefined) && typeof t.userRole === 'string') {
          if (/capo\s*squadra|assistente/i.test(t.userRole)) planned.add(uid);
        }
      }
    }

    // 2) da tasksCodeStructure (già aggregato)
    for (const key of Object.keys(this.tasksCodeStructure || {})) {
      const agg = this.tasksCodeStructure[key];
      if (!agg) continue;
      if (agg.teamLeaderId) planned.add(Number(agg.teamLeaderId));
      for (const aid of (agg.assistantIds || [])) planned.add(Number(aid));
    }

    return planned;
  }

  /** Restituisce l’elenco “Non pianificati” (solo CORE) */
  private computeUnplannedResources(): Array<ResourceBasic> {
    if (this.plannerType !== 'core') return [];

    const plannedIds = this.collectPlannedIdsFromTasks();

    return Array.from(this.allResourcesById.values())
      .filter(r => !plannedIds.has(r.id))
      .sort((a, b) =>
        a.ruolo === b.ruolo ? a.name.localeCompare(b.name) : a.ruolo.localeCompare(b.ruolo)
      );
  }

  getDateFromTimestamp(ts: any) {
    let timestamp = parseInt(ts);
    let date = new Date(timestamp * 1000);
    return new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes()
    );
  }

  getDateFromTimestampWithHour(ts: any, start: boolean = true) {
    let timestamp = parseInt(ts);
    let date = new Date(timestamp * 1000);
    if (start)
      return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        0,
        0
      );
    return new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      23,
      59
    );
  }

  getDateFromTimestampWithHourNotUTC(ts: any, start: boolean = true) {
    let timestamp = parseInt(ts);
    let date = new Date(timestamp * 1000);
    if (start)
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0,
        0
      );
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59
    );
  }

  getDateFromTimestampInPieces(ts: any) {
    let timestamp = parseInt(ts);
    let date = new Date(timestamp * 1000);
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth(),
      day: date.getUTCDate(),
    };
  }

  getEventEdit() {
    return {
      editorConfig: {
        width: '32em',
      },
      items: {
        nameField: { readOnly: true },
        startDateField: false,
        startTimeField: false,
        endDateField: false,
        endTimeField: false,
        recurrenceCombo: false,
        resourceField: false,
        colorField: false,

        assistantsField: {
          type: 'combo',
          name: 'assistants',
          label: 'Assistants',
          required: true,
          multiSelect: true,
          valueField: 'id',
          displayField: 'name',
          weight: 120,
          items: this.assistantOptions,
        },

        eventColorField: {
          label: 'Color',
          type: 'colorField',
          name: 'eventColor',
          items: this.colorValues,
          weight: 213,
          colors: this.colorValues
        },

        notesField: {
          type: 'textAreaField',
          name: 'notes',
          label: 'Notes',
          labelPosition: 'above',
          placeholder: 'Aggiungi note alla commessa…',
          weight: 300,
          autoGrow: true,
          clearable: true,
          maxLength: 2000
        },
      },
    };
  }


  dateForBryntum(date: any) {
    let year = date.getFullYear();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  }

  clickZoomIn(): void {
    this.schedulerPro.zoomIn();
  }

  clickZoomOut(): void {
    this.schedulerPro.zoomOut();
  }

  filterEvents(event: any): void {

    // Se la ricerca è vuota, rimuovi i filtri per mostrare anche chi non ha commesse
    if (!event.value || !event.value.trim()) {
      this.schedulerPro.eventStore.clearFilters?.();
      this.schedulerPro.resourceStore.clearFilters?.();
      this.updateResourceOrdering();
      return;
    }

    const value = event.value.replace(/[.*+?^${}(),[\]\\]/g, '\\$&');
    this.schedulerPro.eventStore.filter({
      filters: (event: any) => event.name.match(new RegExp(value, 'i')),
      replace: true,
    });

    // Filtro i Team Leader sulla base delle commesse ricercate
    this.schedulerPro.resourceStore.filter({
      filters: (resource: any) =>
        resource.events.some((e: any) => e.name.match(new RegExp(value, 'i'))),
      replace: true,
    });
    this.updateResourceOrdering();
  }

  async refreshRows() {
    this.changeViewPlanning();
  }

  getWeekNumber(d: any) {
    // Copy date so don't modify original

    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));

    // Set to nearest Thursday: current date + 4 - current day number

    // Make Sunday's day number 7

    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));

    // Get first day of year

    var yearStart: any = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));

    // Calculate full weeks to nearest Thursday

    var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);

    // Return array of year and week number

    return [d.getUTCFullYear(), weekNo];
  }

  getDateFromUnixTimestamp(timestamp: any) {
    let ts = timestamp * 1000;
    return new Date(ts);
  }

  codeStructureUnion(withFinalBalances = false) {
    // Reset Variabili
    this.events = [];
    this.assignments = [];

    if (withFinalBalances) {
      // Unione eventi e assegnazioni
      let tasksWithFinalBalancesEventsIds =
        this.tasksWithFinalBalancesEvents.map((e: any) => e.id);
      let tasksWitoutFinalBalances = this.tasksEvents.filter(
        (e: any) => !tasksWithFinalBalancesEventsIds.includes(e.id)
      );
      //console.log(this.tasksAssignments)
      let assignmentsWitoutFinalBalances = this.tasksAssignments.filter(
        (e: any) => !tasksWithFinalBalancesEventsIds.includes(e.event)
      );

      this.events = [
        ...this.finalBalancesEvents,
        ...this.tasksWithFinalBalancesEvents,
        ...tasksWitoutFinalBalances,
      ];
      this.assignments = [
        ...this.finalBalancesAssignments,
        ...this.tasksWithFinalBalancesAssignments,
        ...assignmentsWitoutFinalBalances,
      ];
    } else {
      this.events = [...this.tasksEvents, ...[]];
      this.assignments = [...this.tasksAssignments, ...[]];
    }

    // Aggiornamento diello schedulerPro
    if (this.schedulerPro) {
      //console.log('Reload')
      this.schedulerPro.eventStore.data = this.events;
      console.log('notes sample', this.events.slice(0, 3).map((e: any) => ({ id: e.id, notes: e.notes })));

      this.schedulerPro.assignmentStore.data = this.assignments;
      this.kickOrderingLikeSearch();
    }

    if (this.schedulerPro) {
      /*
       this.schedulerPro.overlappingEventSorter = (
         a: any,
         b: any,
       ) => {

         const same = (a.priority == b.priority);

         if (same) {
           return a.prio < b.prio ? -1 : 1;
         } else {
           return (a.prio > b.prio) ? -1 : 1;
         }
       };
       */
    }
  }

  loadFinalBalancers(loading: any = false) {
    console.log('LOAD FINAL BALANCERS');
    if (loading) this.libService.lockPage('');
    let currentUser = this.userSessionService.getState('user');

    // Reset Variabili
    this.finalBalancesCodeStructure = {};
    this.finalBalancesEvents = [];
    this.finalBalancesAssignments = [];

    this.tasksWithFinalBalancesEvents = [];
    this.tasksWithFinalBalancesAssignments = [];

    let tmpDependencies: any = {};

    let testDays: any = {};

    this.planningService
      .getFinalBalancers(currentUser.email, this.orderIds)
      .pipe(
        finalize(() => { this.finalBalancersInFlight = false; })
      ).subscribe((finalBalancers: any) => {
        let tmp_code: any = {};

        finalBalancers.forEach((finalBalancer: any) => {
          //console.log(tmpTask)
          //console.log(finalBalancer)

          Object.entries(finalBalancer.teams).forEach((entry) => {
            const [key, value]: any = entry;

            //console.log(key)
            if (![undefined, null].includes(key)) {
              Object.entries(value.ts).forEach((final) => {
                const [keyFinal, valueFinal]: any = final;
                let tmpDays = valueFinal.days;
                //console.log(tmpDays)

                let code = `${key}_${keyFinal}_${finalBalancer.code}`;
                //console.log('CODE')
                //console.log(code)

                let clientName = finalBalancer.idSubject
                  ? finalBalancer.subjectFullName
                  : finalBalancer.nameAdminCondominius;

                if (!this.finalBalancesCodeStructure[code]) {
                  this.finalBalancesCodeStructure[code] = {
                    teamLeaderId: key,
                    assistantIds: [],
                    days: [],
                    orderCode: finalBalancer.code,
                    orderId: finalBalancer.orderId,
                    eventColor: 'gray',
                    clientName: clientName,
                    nameBuilding: `${finalBalancer.nameBuilding} - ${finalBalancer.city}`,
                    version: finalBalancer.version,
                    deliberateQuantityToBeProduced:
                      finalBalancer.deliberateQuantityToBeProduced,
                    teamLeaderSAL: value.totalQtSal,
                    weekSAL: valueFinal.totalQtSal,
                    totalSAL: finalBalancer.totalQtSal,
                    qtOreManodopera: finalBalancer.qtOreManodopera,
                    deliberateValueToBeProduced:
                      finalBalancer.deliberateValueToBeProduced,
                    totalSALValue: finalBalancer.totalValoreSal,
                    weekSALValue: valueFinal.totalValoreSal,
                    finalBalanceHours: finalBalancer.finalBalanceHours,
                    PassiveHoursTotal: finalBalancer.PassiveHoursTotal,
                    OrderHoursTotal: finalBalancer.OrderHoursTotal,
                    TaskHoursTotal: finalBalancer.TaskHoursTotal,
                    finalBalancerDays: valueFinal.days,
                  };
                }
                this.finalBalancesCodeStructure[code].days = [
                  ...this.finalBalancesCodeStructure[code].days,
                  ...tmpDays,
                ];
              });
            }
          });
        });

        Object.entries(this.finalBalancesCodeStructure).forEach(
          (structurefinalBalance) => {
            const [keyStructure, valueStructure]: any = structurefinalBalance;

            let currentDays = valueStructure.days.sort(function (
              x: any,
              y: any
            ) {
              return x - y;
            });

            let percentDoneTotal = Math.round(
              (valueStructure.totalSAL /
                valueStructure.deliberateQuantityToBeProduced) *
              100
            );
            let percentDoneTeamLeader = Math.round(
              (valueStructure.teamLeaderSAL /
                valueStructure.deliberateQuantityToBeProduced) *
              100
            );
            let percentDoneWeek = Math.round(
              (valueStructure.weekSAL /
                valueStructure.deliberateQuantityToBeProduced) *
              100
            );

            let totalSALValuePercent = Math.round(
              (valueStructure.totalSALValue /
                valueStructure.deliberateValueToBeProduced) *
              100
            );
            let weekSALValuePercent = Math.round(
              (valueStructure.weekSALValue /
                valueStructure.deliberateValueToBeProduced) *
              100
            );

            if (!testDays[keyStructure])
              testDays[keyStructure] = currentDays.map((day: any) =>
                this.getDateFromTimestamp(day)
              );

            let finalBalanceObject = {
              name: `${percentDoneTotal}% - ${valueStructure.orderCode} - ${valueStructure.clientName} - ${valueStructure.nameBuilding}`,
              deliberateQuantityToBeProduced:
                valueStructure.deliberateQuantityToBeProduced.toFixed(2),
              deliberateValueToBeProduced:
                valueStructure.deliberateValueToBeProduced.toFixed(2),
              totalSAL: valueStructure.totalSAL.toFixed(2),
              teamLeaderSAL: valueStructure.teamLeaderSAL.toFixed(2),
              teamLeaderSALpercent: percentDoneTeamLeader,
              weekSAL: valueStructure.weekSAL.toFixed(2),
              weekSALpercent: percentDoneWeek,
              totalSALValue: valueStructure.totalSALValue.toFixed(2),
              totalSALValuePercent: totalSALValuePercent,
              weekSALValue: valueStructure.weekSALValue.toFixed(2),
              weekSALValuePercent: weekSALValuePercent,
              percentDone: percentDoneTotal,
              qtOreManodopera: valueStructure.qtOreManodopera.toFixed(2),
              finalBalanceHours: valueStructure.finalBalanceHours,
              weekCode: keyStructure,
              PassiveHoursTotal: valueStructure.PassiveHoursTotal,
              OrderHoursTotal: valueStructure.OrderHoursTotal,
              TaskHoursTotal: valueStructure.TaskHoursTotal,
              currentDays: currentDays,
              weekDays: currentDays.map((day: any) =>
                moment.unix(day).format('dd')
              ),
              alreadyProcessed: false,
              finalBalancerDays: valueStructure.finalBalancerDays,
            };

            const oid = valueStructure.orderId;
            const m = this.metricsByOrderId.get(oid) || {};
            m.totalValoreSal = valueStructure.totalSALValue;                 // totalValoreSal
            m.deliberateValueToBeProduced = valueStructure.deliberateValueToBeProduced;
            this.computeDerivedMetrics(m);
            this.metricsByOrderId.set(oid, m);

            //   const tmpTaskToChange = this.tasksWithFinalBalancesEvents.findIndex(
            //     (task: any) => {
            //       return task.multipleCodeWeek.includes(keyStructure);
            //     }
            //   );

            //   const taskToChange = this.tasksEvents.findIndex((task: any) => {
            //     return task.multipleCodeWeek.includes(keyStructure);
            //   });

            //   let newTaskToChange = this.getAllIndexes(
            //     this.tasksEvents,
            //     keyStructure
            //   );

            //   if (tmpTaskToChange != -1) {
            //     // Casistica in cui è già stata fatta un primo aggangio del consuntivo

            //     this.tasksWithFinalBalancesEvents[tmpTaskToChange].weekSAL =
            //       parseInt(
            //         this.tasksWithFinalBalancesEvents[tmpTaskToChange].weekSAL
            //       ) + parseInt(finalBalanceObject.weekSAL);
            //     this.tasksWithFinalBalancesEvents[tmpTaskToChange].weekSALValue =
            //       parseInt(
            //         this.tasksWithFinalBalancesEvents[tmpTaskToChange]
            //           .weekSALValue
            //       ) + parseInt(finalBalanceObject.weekSALValue);

            //     this.tasksWithFinalBalancesEvents[
            //       tmpTaskToChange
            //     ].weekSALpercent = Math.round(
            //       (this.tasksWithFinalBalancesEvents[tmpTaskToChange].weekSAL /
            //         valueStructure.deliberateQuantityToBeProduced) *
            //       100
            //     );
            //     this.tasksWithFinalBalancesEvents[
            //       tmpTaskToChange
            //     ].weekSALValuePercent = Math.round(
            //       (this.tasksWithFinalBalancesEvents[tmpTaskToChange]
            //         .weekSALValue /
            //         valueStructure.deliberateValueToBeProduced) *
            //       100
            //     );

            //     this.tasksWithFinalBalancesEvents[tmpTaskToChange].weekDays = [
            //       ...this.tasksWithFinalBalancesEvents[tmpTaskToChange].weekDays,
            //       ...finalBalanceObject.weekDays,
            //     ];
            //   } else if (newTaskToChange.length != 0) {
            //     // Casistica in cui è la prima volta in cui viene fatto un aggancio di consuntivo
            //     newTaskToChange.forEach((taskToChange) => {
            //       let tmpTasksWithFinalBalances = Object.assign(
            //         {},
            //         this.tasksEvents[taskToChange]
            //       );

            //       tmpTasksWithFinalBalances.withFinalBalancer = true;
            //       Object.entries(finalBalanceObject).forEach((object) => {
            //         const [keyObject, valueObject]: any = object;
            //         tmpTasksWithFinalBalances[keyObject] = valueObject;
            //       });
            //       tmpTasksWithFinalBalances.finalBalancer = false;
            //       this.tasksWithFinalBalancesEvents.push(
            //         tmpTasksWithFinalBalances
            //       );
            //       this.tasksWithFinalBalancesAssignments.push({
            //         event: tmpTasksWithFinalBalances.id,
            //         resource: valueStructure.teamLeaderId,
            //       });
            //     });
            //   } else {
            //     // Casistica in cui non esiste un evento a cui agganciare il consuntivo

            //     let lastIndex = currentDays.length - 1;
            //     if (currentDays.length == 1) lastIndex = 0;

            //     //console.log(keyStructure)
            //     //console.log(valueStructure.orderCode)
            //     //console.log(currentDays)
            //     //console.log(currentDays.map((cd: any) => this.getDateFromTimestamp(cd)))
            //     //console.log(this.getDateFromTimestampWithHourNotUTC(currentDays[0], true))
            //     //console.log(this.getDateFromTimestampWithHourNotUTC(currentDays[lastIndex], false))

            //     // SAL TEAM LEADER
            //     let tmpEvent: any = {
            //       id: keyStructure,
            //       startDate: this.getDateFromTimestampWithHourNotUTC(
            //         currentDays[0],
            //         true
            //       ),
            //       endDate: this.getDateFromTimestampWithHourNotUTC(
            //         currentDays[lastIndex],
            //         false
            //       ),
            //       name: `${percentDoneTotal}% - ${valueStructure.orderCode} - ${valueStructure.clientName} - ${valueStructure.nameBuilding}`,
            //       code: valueStructure.orderCode,
            //       clientName: valueStructure.clientName,
            //       nameBuilding: valueStructure.nameBuilding,
            //       assistants: '',
            //       eventColor: 'gray',
            //       draggable: false,
            //       resizable: false,
            //       finalBalancer: true,
            //       prio: 'low',
            //     };

            //     Object.entries(finalBalanceObject).forEach((object) => {
            //       const [keyObject, valueObject]: any = object;
            //       tmpEvent[keyObject] = valueObject;
            //     });

            //     /*
            // this.dependencies.push({
            //   "id"        : 1,
            //   "fromEvent" : keyStructure,
            //   "toEvent"   : keyStructure
            // },)
            // */

            //     this.finalBalancesEvents.push(tmpEvent);
            //     this.finalBalancesAssignments.push({
            //       event: keyStructure,
            //       resource: valueStructure.teamLeaderId,
            //     });
            //   }
            const matchingTaskIdxs = this.getAllIndexes(this.tasksEvents, keyStructure);

            if (matchingTaskIdxs.length) {
              // per TUTTI i task che hanno quel multipleCodeWeek, applica/accumula i dati del consuntivo
              for (const idx of matchingTaskIdxs) {
                const ev = this.tasksEvents[idx];

                this.applyFinalBalanceToTask(
                  ev,
                  finalBalanceObject,
                  {
                    deliberateQty: Number(valueStructure.deliberateQuantityToBeProduced),
                    deliberateVal: Number(valueStructure.deliberateValueToBeProduced)
                  }
                );
                const m = this.metricsByOrderId.get(valueStructure.orderId);
                if (m) this.stampMetrics(ev, m);


              }
            } else {
              // **come prima**: non esiste un task → crea evento “solo consuntivo”
              let lastIndex = currentDays.length - 1;
              if (currentDays.length == 1) lastIndex = 0;

              let tmpEvent: any = {
                id: keyStructure,
                startDate: this.atLocalHour(currentDays[0], 9, 0),
                endDate: this.atLocalHour(currentDays[lastIndex], 18, 0),
                name: `${percentDoneTotal}% - ${valueStructure.orderCode} - ${valueStructure.clientName} - ${valueStructure.nameBuilding}`,
                code: valueStructure.orderCode,
                clientName: valueStructure.clientName,
                nameBuilding: valueStructure.nameBuilding,
                assistants: '',
                eventColor: 'gray',
                draggable: false,
                resizable: false,
                finalBalancer: true,
                prio: 'low',
              };

              Object.entries(finalBalanceObject).forEach(([k, v]: any) => { tmpEvent[k] = v; });
              const m = this.metricsByOrderId.get(valueStructure.orderId);
              if (m) this.stampMetrics(tmpEvent, m);

              this.finalBalancesEvents.push(tmpEvent);
              this.finalBalancesAssignments.push({
                event: keyStructure,
                resource: valueStructure.teamLeaderId,
              });
            }

          }
        );

        //console.log(testDays)

        for (const ev of this.tasksEvents) {
          const m = this.metricsByOrderId.get(ev.orderId);
          if (!m) continue;
          this.stampMetrics(ev, m);

        }
        this.stampMetricsOnAllEvents();
        this.codeStructureUnion();
        //console.log(this.finalBalancesEvents)
        //console.log(tmpDependencies)

        //  if (loading) this.libService.unlockPage();
      });
  }



  getAllIndexes(arr: any, val: any) {
    var indexes = [],
      i;
    for (i = 0; i < arr.length; i++)
      if (arr[i]?.multipleCodeWeek.includes(val)) indexes.push(i);
    return indexes;
  }

  showFinalBalances(event: any) {
    this.codeStructureUnion(event.checked);
  }

  fullPlanning() {
    console.log('fullPlanning');
    this.fullScreen = !this.fullScreen;
    this.setPlanningFullScreen.next(this.fullScreen);
  }
  private idToUsername = (id: number | string): string => {
    const sId = String(id);

    const r = this.resourcesList?.find?.((u: any) => String(u.id) === sId);
    if (r?.name) return r.name;

    return sId;
  };
  private idsToUsernames = (ids: Array<number | string> = []): string[] =>
    ids.map(id => this.idToUsername(id));

  private clampStartBeforeNine(d: Date | string): string {
    return moment(d).utc(true).hours(8).minutes(59).seconds(59).milliseconds(0).toISOString();
  }
  private clampEndAfterTwenty(d: Date | string): string {
    return moment(d).utc(true).hours(20).minutes(59).seconds(59).milliseconds(999).toISOString();
  }

  /** Restituisce le commesse uniche arricchite con startDate/endDate calcolate dai task visibili */
  private buildOrdersForDialog(): any[] {
    const ranges: Record<number, { start: number; end: number; order: any }> = {};

    for (const t of (this.rawTasks || [])) {
      const o = t?.Order;
      if (!o?.id) continue;

      const s = Number(t.tsStart) * 1000; // ms
      const e = Number(t.tsEnd) * 1000;   // ms
      if (!Number.isFinite(s) || !Number.isFinite(e)) continue;

      if (!ranges[o.id]) {
        ranges[o.id] = { start: s, end: e, order: o };
      } else {
        if (s < ranges[o.id].start) ranges[o.id].start = s;
        if (e > ranges[o.id].end) ranges[o.id].end = e;
      }
    }

    // crea array unico con i campi startDate/endDate (Date)
    return Object.values(ranges).map(r => ({
      ...r.order,
      startDate: new Date(r.start),
      endDate: new Date(r.end),
    }));
  }


  editOperators() {
    const currentUser = this.userSessionService.getState('user');
    const userEmail = currentUser?.email;

    const orders = this.buildOrdersForDialog();
    console.log('orders with dates:', orders);

    const dialogRef = this.dialog.open(EditOperatorsDialogComponent, {
      data: {
        orders,
        resources: this.resourcesList,
        tasks: this.rawTasks,
        absencesByUser: this.absencesByUser,
        absencesDetailsByUser: this.absencesDetailsByUser,
      },
      scrollStrategy: new NoopScrollStrategy(),
      disableClose: true,
      width: '760px',
      autoFocus: false,
      restoreFocus: false,
    });

    dialogRef.afterClosed().pipe(
      take(1),
      filter((payload) => this.isValidReplacementPayload(payload)),

      // 👇 salva il RAW per poter riaprire la modale con gli stessi dati
      tap((raw) => { this.lastEditFormValue = raw; }),

      map((payload) => {
        const { dates, ...rest } = payload || {};
        const rawBlocks = Array.isArray(payload?.date) ? payload.date
          : Array.isArray(dates) ? dates : [];

        const clampedBlocks = rawBlocks.map((b: any) => ({
          startDate: this.clampStartBeforeNine(b.startDate),
          endDate: this.clampEndAfterTwenty(b.endDate),
        }));

        return {
          ...rest,
          date: clampedBlocks,
          currentUser: userEmail,
        };
      }),

      switchMap((payloadConWho) =>
        this.planningService.resourceReplacement(payloadConWho).pipe(
          catchError((err) =>
            of({
              success: false,
              code: 'NETWORK_ERROR',
              message: err?.error?.message || err?.message || 'Errore di rete',
            })
          )
        )
      )
    ).subscribe((res: any) => this.handleReplacementResponse(res));
  }

  private isValidReplacementPayload(p: any): boolean {
    if (!p) return false;

    const hasOrder =
      p.orderId != null &&
      ((Array.isArray(p.orderId) && p.orderId.length > 0) || !Array.isArray(p.orderId));

    const hasResources =
      Array.isArray(p.resources) &&
      p.resources.length > 0 &&
      p.resources.every((r: any) => r?.resourcesToReplace && r?.resourcesToAdd);

    const blocks = Array.isArray(p.date) ? p.date : Array.isArray(p.dates) ? p.dates : [];
    const hasDates = blocks.length > 0 && blocks.every((b: any) => b?.startDate && b?.endDate);

    return hasOrder && hasResources && hasDates;
  }



  /** Mostra popup chiari in base alla response del backend */
  private handleReplacementResponse(res: any): void {
    if (res?.success) {
      const updated = res.updatedCount ?? 0;
      const skipped = res.skippedCount ?? 0;
      if (updated === 0 && skipped === 0) {
        this.toastr.info(
          this.translate.instant('PLANNER.REPLACEMENT.NO_CHANGES'),
          this.translate.instant('PLANNER.REPLACEMENT.TITLE')
        );
        return;
      }
      let msg = this.translate.instant('PLANNER.REPLACEMENT.UPDATED_N', { n: updated });
      if (skipped > 0) {
        msg += ' ' + this.translate.instant('PLANNER.REPLACEMENT.SKIPPED_N', { n: skipped });
      }
      this.toastr.success(msg, this.translate.instant('PLANNER.REPLACEMENT.DONE'));
      this.loadTasks(true);
      return;
    }

    // --- NON success: mostra i toast specifici ---
    const code = res?.code || 'UNEXPECTED_ERROR';
    let reopenMsg = ''; // messaggio da riusare nel mini-dialog

    switch (code) {
      case 'CONTRACTS_MISSING': {
        const users = this.idsToUsernames(res?.details?.missingUserIds).join(', ');
        reopenMsg = this.translate.instant('PLANNER.REPLACEMENT.CONTRACTS_MISSING_MSG', { ids: users });
        this.toastr.error(reopenMsg, this.translate.instant('PLANNER.REPLACEMENT.NOT_EXECUTED'));
        break;
      }
      case 'NO_MATCHING_TASKS_IN_RANGE': {
        const r = res?.details?.range || {};
        const users = this.idsToUsernames(res?.details?.userIdsToReplace).join(', ') || '—';
        const start = r.start ? moment(r.start).format('DD/MM/YYYY HH:mm') : '—';
        const end = r.end ? moment(r.end).format('DD/MM/YYYY HH:mm') : '—';
        reopenMsg = this.translate.instant('PLANNER.REPLACEMENT.NO_MATCHING_TASKS_MSG', { users, start, end });
        this.toastr.info(reopenMsg, this.translate.instant('PLANNER.REPLACEMENT.NO_ITEMS_TITLE'));
        break;
      }
      case 'NO_TASKS_FOR_ORDER': {
        const ord = res?.details?.orderId ?? '—';
        reopenMsg = this.translate.instant('PLANNER.NO_TASKS_FOR_ORDER', { ord });
        this.toastr.info(reopenMsg, this.translate.instant('PLANNER.NO_ITEMS'));
        break;
      }
      case 'NETWORK_ERROR': {
        reopenMsg = res?.message || this.translate.instant('PLANNER.NETWORK_ERROR');
        this.toastr.error(reopenMsg, this.translate.instant('PLANNER.ERROR'));
        break;
      }
      case 'USER_ABSENT_IN_RANGE': {
        const uid = res?.details?.userId;
        const userName = this.idToUsername?.(uid) || uid || '—';
        const abs = Array.isArray(res?.details?.absences) ? res.details.absences : [];
        const absMsg = abs.length ? ` (${abs.join(', ')})` : '';
        reopenMsg = this.translate.instant('PLANNER.UserAbsentInRangeMsg', { user: userName }) + absMsg;
        this.toastr.error(this.translate.instant('PLANNER.UserAbsentInRangeMsg', { user: userName }),
          this.translate.instant('TOASTR.ERROR'));
        break;
      }
      default: {
        reopenMsg = res?.message || this.translate.instant('PLANNER.ERROR');
        this.toastr.error(reopenMsg, `${this.translate.instant('PLANNER.ERROR')} (${code})`);
      }
    }

    // --- Chiedi se riaprire con i dati precedenti ---
    if (this.lastEditFormValue) {
      this.openReopenConfirm(
        `${reopenMsg}\n\n${this.translate.instant('PLANNER.ReopenWithPrevData')
        || 'Vuoi riaprire la modale con i dati inseriti per correggerli?'}`
      ).subscribe((agree) => {
        if (agree) this.openEditOperatorsWithInitial(this.lastEditFormValue!);
      });
    }
  }


  private openReopenConfirm(message?: string) {
    const ref = this.dialog.open(this.reopenConfirmTpl, {
      width: '420px',
      data: {
        title: this.translate.instant('PLANNER.RequestFailedTitle') || 'Richiesta non riuscita',
        message: message || this.translate.instant('PLANNER.ReopenWithPrevData')
          || 'La richiesta è andata in errore. Vuoi riaprire la modale con i dati inseriti per correggerli?',
        okLabel: this.translate.instant('LABEL.YES') || 'Sì, riapri',
        cancelLabel: this.translate.instant('LABEL.NO') || 'No',
      },
      scrollStrategy: new NoopScrollStrategy(),

    });
    return ref.afterClosed().pipe(take(1));
  }
  private openEditOperatorsWithInitial(initialFormValue: any) {
    const orders = this.buildOrdersForDialog();
    this.dialog.open(EditOperatorsDialogComponent, {
      data: {
        orders,
        resources: this.resourcesList,
        tasks: this.rawTasks,
        absencesByUser: this.absencesByUser,
        absencesDetailsByUser: this.absencesDetailsByUser,
        initialFormValue, // 👈 qui i dati vecchi
      },
      scrollStrategy: new NoopScrollStrategy(),
      disableClose: true,
      width: '760px',
      autoFocus: false,
      restoreFocus: false,
    });
  }

  /**
   * Called after View is initialized
   */
  ngAfterViewInit(): void {
    const currentUser = this.userSessionService.getState('user');
    this.reloadForCurrentMonth();
    // SchedulerPro instance
    this.schedulerPro = this.schedulerProComponent.instance;
    // this.schedulerPro.on('beforeEventRender', ({ eventRecord, renderData }: any) => {
    //   renderData.iconCls = eventRecord.iconCls; // mantiene il corner-icon
    // });
    if (this.plannerType === 'core') {
      // elemento DOM della grid bloccata (colonne risorse, a sinistra)
      const lockedEl = (this.schedulerPro as any)?.subGrids?.locked?.element;
      if (!lockedEl) return;

      // Tooltip che si apre su click sulla colonna 'name'
      this.clickTip = new Tooltip({
        forElement: lockedEl,
        forSelector: '.b-grid-cell[data-column="name"]', // limita al nome risorsa
        anchorToTarget: true,
        cls: 'planner-click-tip',
        maxWidth: 380,
        allowOver: true,
        trackMouse: false,

        // genera l'HTML del tooltip a partire dalla cella cliccata
        getHtml: ({ activeTarget }: any): string => {
          const cellEl = activeTarget as HTMLElement;
          const rowEl = cellEl.closest('.b-grid-row') as HTMLElement | null;
          const recId: any = rowEl?.dataset?.['id'];

          const rec: any = recId ? this.schedulerPro.resourceStore.getById(recId) : null;
          if (!rec) return '';

          const tlId = Number(rec.get ? rec.get('id') : rec.id);
          const meta = this.allResourcesById.get(tlId) as (ResourceBasic | undefined);
          const nameFromRec = rec.get ? rec.get('name') : rec.name;
          const name = meta?.name ?? String(nameFromRec ?? '');

          // Dati (fallback a 0 se assenti)
          const pian = this.planningByTL.get(tlId) ?? {
            idCaposquadra: tlId,
            ProgrammatoCsq: 0,
            ProgrammatoSquadraStandardNetto: 0,
            SogliaPremioProgrammazione: 0,
            PremioCsqTeorico: 0,
            GettoneCsqTeorico: 0
          } as TLPlanningRow;

          const cons = this.consByTL.get(tlId) ?? {
            idCaposquadra: tlId,
            AvanzamentoProduzione: 0,
            CostoMateriali: 0,
            ['Materiali%']: 0,
            CostoMDO: 0,
            ['MDO%']: 0,
            MLC: 0,
            ['MLC%']: 0,
            AvanzamentoProduzioneSQST: 0
          } as TLConsRow;

          // Calcoli %
          const percAvanzamento = pian.ProgrammatoCsq ? (cons.AvanzamentoProduzione / pian.ProgrammatoCsq) * 100 : 0;
          const percMateriali = cons['Materiali%'] ?? 0;
          const percMDO = cons['MDO%'] ?? 0;
          const percMLC = cons['MLC%'] ?? 0;

          const esc = (s: unknown) =>
            String(s ?? '').replace(/[<>&]/g, c => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]!));

          // Stili inline semplici + separatori
          const sep = `<tr><td colspan="3"><div style="border-top:1px solid #e0e0e0; margin:6px 0;"></div></td></tr>`;

          return `
  <div style="padding:8px 10px; max-width:380px;">
    <div style="font-weight:600; margin-bottom:6px;">${esc(name)}</div>
    <table style="font-size:12px; border-collapse:collapse; width:100%;">
      <tr>
        <td style="padding:2px 6px; white-space:nowrap;">Programmato del mese CSQ</td>
        <td style="padding:2px 0; text-align:right;"><strong>${this.fmtEUR(pian.ProgrammatoCsq)}</strong></td>
        <td style="padding-left:16px; min-width:60px;"></td>
      </tr>
      <tr>
        <td style="padding:2px 6px; white-space:nowrap;">Avanzamento produzione</td>
        <td style="padding:2px 0; text-align:right;">${this.fmtEUR(cons.AvanzamentoProduzione)}</td>
        <td style="padding-left:16px; min-width:60px; text-align:right;">${this.fmtPerc(percAvanzamento, 2)}</td>
      </tr>
      <tr>
        <td style="padding:2px 6px; white-space:nowrap;">Costo materiali</td>
        <td style="padding:2px 0; text-align:right;">${this.fmtEUR(cons.CostoMateriali)}</td>
        <td style="padding-left:16px; min-width:60px; text-align:right; ${this.pctClass('mat', percMateriali)}">${this.fmtPerc(percMateriali, 2)}</td>
      </tr>
      <tr>
        <td style="padding:2px 6px; white-space:nowrap;">Costo mano d'opera</td>
        <td style="padding:2px 0; text-align:right;">${this.fmtEUR(cons.CostoMDO)}</td>
        <td style="padding-left:16px; min-width:60px; text-align:right; ${this.pctClass('mdo', percMDO)}">${this.fmtPerc(percMDO, 2)}</td>
      </tr>
      <tr>
        <td style="padding:2px 6px; white-space:nowrap;">MLC</td>
        <td style="padding:2px 0; text-align:right;">${this.fmtEUR(cons.MLC)}</td>
        <td style="padding-left:16px; min-width:60px; text-align:right; ${this.pctClass('mlc', percMLC)}">${this.fmtPerc(percMLC, 2)}</td>
      </tr>

      ${sep}

      <tr>
        <td style="padding:2px 6px; white-space:nowrap;">Programmato SQ standard netto</td>
        <td style="padding:2px 0; text-align:right;">${this.fmtEUR(pian.ProgrammatoSquadraStandardNetto)}</td>
        <td style="padding-left:16px; min-width:60px;"></td>
      </tr>
      <tr>
        <td style="padding:2px 6px; white-space:nowrap;">Soglia premio programmazione</td>
        <td style="padding:2px 0; text-align:right;">${this.fmtEUR(pian.SogliaPremioProgrammazione)}</td>
        <td style="padding-left:16px; min-width:60px;"></td>
      </tr>
      <tr>
        <td style="padding:2px 6px; white-space:nowrap;">Gettone teorico CSQ</td>
        <td style="padding:2px 0; text-align:right;">${this.fmtEUR(pian.GettoneCsqTeorico)}</td>
        <td style="padding-left:16px; min-width:60px;"></td>
      </tr>
      <tr>
        <td style="padding:2px 6px; white-space:nowrap;">Premio teorico CSQ</td>
        <td style="padding:2px 0; text-align:right;"><strong>${this.fmtEUR(pian.PremioCsqTeorico)}</strong></td>
        <td style="padding-left:16px; min-width:60px;"></td>
      </tr>

      ${sep}

      <tr>
        <td style="padding:2px 6px; white-space:nowrap;">Avanzamento produzione SQ ST</td>
        <td style="padding:2px 0; text-align:right;">${this.fmtEUR(cons.AvanzamentoProduzioneSQST)}</td>
        <td style="padding-left:16px; min-width:60px;"></td>
      </tr>
    </table>
    <div style="font-size:11px;opacity:.7;margin-top:6px;">Periodo: ${esc(this.lastMonthKey?.replace('-', '/'))}</div>
  </div>
`;

        }


      } as any); // 👈 necessario per accettare showOn / hideOn

      // Imposta trigger manualmente (le typings non le espongono)
      (this.clickTip as any).showOn = 'click';
      (this.clickTip as any).hideOn = 'clickout';

      // (facoltativo) cursore “clickable” sulla cella name
      lockedEl.addEventListener(
        'mouseenter',
        (e: any) => {
          const cell = e.target?.closest?.('.b-grid-cell[data-column="name"]');
          if (cell) cell.style.cursor = 'pointer';
        },
        { capture: true, passive: true }
      );
    }

    this.schedulerPro.on('timeAxisChange', () => {
      this.rebuildAbsenceDayMarkers();
      this.reloadForCurrentMonth();
      this.updateResourceOrdering();
    });
    this.schedulerPro.resourceStore.on('change', () => this.rebuildAbsenceDayMarkers());
    this.schedulerPro.eventStore.on({ change: this.updateResourceOrdering, thisObj: this });
    this.schedulerPro.assignmentStore.on({ change: this.updateResourceOrdering, thisObj: this });
    this.schedulerPro.resourceStore.on({ change: this.updateResourceOrdering, thisObj: this });


    this.applySchedulerLocale(this.translate.currentLang);
    this.translate.onLangChange.subscribe((event: any) => {
      this.applySchedulerLocale(event.lang);
      this.consuntivoLabel = this.translate.instant('SIDEBAR.Consuntivi');
      // console.log(this.schedulerPro)
    });

    this.schedulerPro.scrollToDate(new Date(), {
      block: 'start',
    });

    const {
      zoomInButton,
      zoomOutButton,
      filterByName,
      loadTasksButton,
      showFinalBalances,
      fullPlanning,
      startDateField,
      endDateField,
      editOperators,
    } = this.schedulerPro.widgetMap as {
      loadTasksButton: Button;
      zoomInButton: Button;
      zoomOutButton: Button;
      filterByName: TextField;
      showFinalBalances: Checkbox;
      fullPlanning: Button;
      startDateField: DateField;
      endDateField: DateField;
      editOperators: Button;
    };

    loadTasksButton.on({ click: this.refreshRows, thisObj: this });
    zoomInButton.on({ click: this.clickZoomIn, thisObj: this });
    zoomOutButton.on({ click: this.clickZoomOut, thisObj: this });
    filterByName.on({ change: this.filterEvents, thisObj: this });
    showFinalBalances.on({ change: this.showFinalBalances, thisObj: this });
    fullPlanning.on({ click: this.fullPlanning, thisObj: this });
    startDateField.on({ change: this.setStartDate, thisObj: this });
    endDateField.on({ change: this.setEndDate, thisObj: this });
    editOperators.on({ click: this.editOperators, thisObj: this });

    this.schedulerPro.on('beforeeventdropfinalize', ({ context }: any) => {
      console.log('EVENTO SPOSTATO');
      context.async = true;

      // Range destinazione (post-drop) normalizzato a giorni interi in UTC
      const newStart = this.setDateToUTCZone(context.startDate);
      const newEnd = this.setDateToUTCZone(context.endDate);

      // TL di destinazione (se cambia riga) altrimenti quello originale
      const targetTL =
        context?.newResource?.originalData?.id ??
        context?.eventRecord?.originalData?.teamLeaderId;

      // Assistenti dell’evento
      const assistantIds: number[] = context?.eventRecord?.originalData?.assistants ?? [];

      // Partecipanti da verificare
      const participants: number[] = [targetTL, ...assistantIds].filter(
        (v) => typeof v === 'number' && !Number.isNaN(v)
      );

      // Costruisci array di giorni YMD inclusivi
      const daysYMD: string[] = [];
      {
        const d = new Date(Date.UTC(newStart.getUTCFullYear(), newStart.getUTCMonth(), newStart.getUTCDate()));
        const end = new Date(Date.UTC(newEnd.getUTCFullYear(), newEnd.getUTCMonth(), newEnd.getUTCDate()));
        while (d.getTime() <= end.getTime()) {
          const y = d.getUTCFullYear();
          const m = String(d.getUTCMonth() + 1).padStart(2, '0');
          const dd = String(d.getUTCDate()).padStart(2, '0');
          daysYMD.push(`${y}-${m}-${dd}`);
          d.setUTCDate(d.getUTCDate() + 1);
        }
      }

      // Verifica assenze e mostra conferma se necessario
      const conflicts = this.getAbsenceConflictsFor(participants, daysYMD);

      const proceed = () => {
        this.libService.lockPage('');
        const currentUser = this.userSessionService.getState('user');
        const structure = this.getStructureForDrop(context, currentUser);
        const code = this.getCode(context);

        this.planningService.updateSchedule(code, structure).subscribe(
          () => {
            context.finalize(true);
            this.libService.unlockPage();
            this.loadTasks(true);
          },
          () => {
            context.finalize(false);
            this.libService.unlockPage();
          }
        );
      };

      if (conflicts.users.length > 0) {
        const title = this.translate.instant('PLANNER.ABSENCE_CONFIRM.TITLE');
        const msg = this.translate.instant('PLANNER.ABSENCE_CONFIRM.MESSAGE', {
          operators: conflicts.users.join(', '),
          dates: conflicts.dates.join(', ')
        });

        MessageDialog.confirm({
          title,
          message: msg
        }).then((result: number) => {
          if (result === 1) {
            // Confermato: prosegui (le assenze non saranno conteggiate)
            proceed();
          } else {
            // Annulla
            context.finalize(false);
          }
        });

      } else {
        // Nessuna assenza → procedi direttamente
        proceed();
      }
    });



    this.schedulerPro.on('timeAxisHeaderContextMenu', ({ source, startDate, endDate, event }: { source: TimeAxisColumn | VerticalTimeAxisColumn; startDate: Date; endDate: Date; event: Event }) => {
      // 👉 clamp locale: 00:00 del giorno di start
      const startLocal = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0, 0);

      // 👉 Bryntum ti passa end come *inizio del giorno successivo* (esclusivo).
      //    Lo rendiamo inclusivo sottraendo 1 ms, quindi diventa 23:59:59.999 dello stesso giorno.
      const endLocalExclusive = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0, 0);
      const endLocal = new Date(endLocalExclusive.getTime() - 1);

      const summary = this.generateOperatorPlanningSummary(this.operatorPlanningSummary, startLocal, endLocal);

      const absencesMap = Object.fromEntries(
        Object.entries(this.absencesByUser).map(([k, set]) => [k, Array.from(set as Set<string>)])
      );

      const unplannedResources = (this.plannerType === 'core') ? this.computeUnplannedResources() : [];
      const resourcesIndex = this.buildResourcesIndex();

      this.dialog.open(plannerRiepilogoDialogComponent, {
        width: '800px',
        data: {
          summary,
          startDate: startLocal,
          endDate: endLocal,
          dataRangeStart: this.planningStartDate,
          dataRangeEnd: this.planningEndDate,
          absencesByUser: absencesMap,
          absencesDetailsByUser: this.absencesDetailsByUser,
          unplannedResources,
          resourcesIndex
        },
        scrollStrategy: new NoopScrollStrategy(),
      });

    });

    this.schedulerPro.on('beforeEventResizeFinalize', async ({ context }: any) => {
      console.log('EVENTO RIDIMENSIONATO');

      // vecchio range
      const oldStart: Date = context.eventRecord.startDate;
      const oldEnd: Date = context.eventRecord.endDate;

      // nuovo range calcolato come già fai
      let startDate = this.setDateToUTCZone(context.startDate);
      let endDate = this.setDateToUTCZone(context.endDate);
      if (context.edge == 'right') {
        endDate = this.setDateToUTCZone(context.date);
      } else {
        startDate = this.setDateToUTCZone(context.date);
      }

      // giorni “nuovi” aggiunti (solo se ampliamento)
      const addedDays = this.getAddedDaysForResize(oldStart, oldEnd, startDate, endDate);

      // se non ampli, procedi come prima
      if (!addedDays.length) {
        // --- codice esistente (lock, async, structure, API) ---
        let currentUser = this.userSessionService.getState('user');
        this.libService.lockPage('');
        context.async = true;
        const structure = this.getStructureForResize(context, startDate, endDate, currentUser);
        const code = this.getCode(context);

        this.planningService.resizePlanning(code, structure).subscribe(
          () => { context.finalize(true); this.libService.unlockPage(); this.loadTasks(true); },
          () => { context.finalize(false); this.libService.unlockPage(); }
        );
        return;
      }

      // partecipanti dell’evento
      const tlId = context.eventRecord?.teamLeaderId;
      const assistants = context.eventRecord?.assistants ?? [];
      const participants: number[] = [tlId, ...assistants];

      const conflicts = this.findAbsenceConflicts(addedDays, participants);
      if (conflicts.length) {
        const ok = await this.confirmAbsences(conflicts, 'resize');
        if (!ok) {
          context.finalize(false);
          return;
        }
      }

      // --- codice esistente (lock, async, structure, API) ---
      let currentUser = this.userSessionService.getState('user');
      this.libService.lockPage('');
      context.async = true;
      const structure = this.getStructureForResize(context, startDate, endDate, currentUser);
      const code = this.getCode(context);

      this.planningService.resizePlanning(code, structure).subscribe(
        () => { context.finalize(true); this.libService.unlockPage(); this.loadTasks(true); },
        () => { context.finalize(false); this.libService.unlockPage(); }
      );
    });


    this.schedulerPro.on('beforeEventEdit', (event: any) => {
      console.log('EDIT');
      //console.log(event)

      // Rimozione degli utenti con due ruoli, ha dato problemi il 24/08/2023 per la sede di "Perpignan 1"
      let tmpAssistantOptions: any = [];
      let countId: any = [];
      this.assistantOptions.forEach((assistant: any) => {
        if (!countId.includes(assistant.id))
          tmpAssistantOptions.push(assistant);
        countId.push(assistant.id);
      });

      event.eventEdit.editor.widgetMap.assistantsField.items =
        tmpAssistantOptions;
      navigator.clipboard.writeText(event.eventRecord.code);

      // Se l'evento è una vecchi pianificazione o un evento di consuntivazione blocca l'azione
      let status = false;
      status =
        (event.eventRecord.old && !event.eventRecord.finalBalancer) ||
        event.eventRecord.finalBalancer;
      return !status;
    });

    this.schedulerPro.on('eventMenuBeforeShow', (event: any) => {
      console.log('SHOW MENU');
      //console.log(event)
      navigator.clipboard.writeText(event.eventRecord.code);

      // Se l'evento è una vecchi pianificazione o un evento di consuntivazione blocca l'azione
      let status = false;
      status =
        (event.eventRecord.old && !event.eventRecord.finalBalancer) ||
        event.eventRecord.finalBalancer;
      return !status;
    });

    this.schedulerPro.on('beforePaste', async (event: any): Promise<boolean> => {
      // target TL (riga) + assistenti dell’evento copiato
      const teamLeaderId = event.resourceRecord?.originalData?.id;
      const assistantIds = event.eventRecords?.[0]?.assistants ?? [];
      const participants: number[] = [teamLeaderId, ...assistantIds];

      // nuovo range incollato = stessa durata dell’originale
      const origStart: Date = event.eventRecords[0].startDate;
      const origEnd: Date = event.eventRecords[0].endDate;
      const durationMs = origEnd.getTime() - origStart.getTime();

      const newStart: Date = this.setDateToUTCZone(event.date);
      const newEnd: Date = new Date(newStart.getTime() + durationMs);

      const daysYMD = this.listDaysYMD(newStart, newEnd);
      const conflicts = this.findAbsenceConflicts(daysYMD, participants);

      if (conflicts.length) {
        const ok = await this.confirmAbsences(conflicts, 'copy');
        if (!ok) {
          // annulla incolla
          return false;
        }
      }

      // gestisci tu il copy via API
      const resources = [...this.getAssistants(assistantIds), this.getTeamLeader(teamLeaderId)];
      const currentUser = this.userSessionService.getState('user');
      const structure = this.getStructureForCopy(event, resources, currentUser);
      const code = structure.id;

      this.planningService.copyPlanning(code, structure).subscribe(
        () => {
          this.libService.unlockPage();
          this.loadTasks(true);
        },
        () => {
          this.libService.unlockPage();
        }
      );

      // blocca SEMPRE il default paste di Bryntum (lo stai gestendo tu)
      return false;
    });


    this.schedulerPro.on('beforeDragCreate', (resource: any) => {
      // console.log('beforeDragCreate')
      return false;
    });

    this.schedulerPro.on(
      'beforeEventDelete',
      ({ eventRecords, context }: any) => {
        console.log('RIMUOVI');
        console.log(eventRecords);
        //console.log(context)
        let code = eventRecords[0].id;
        // Show custom confirmation dialog (pseudo code)
        let structure = this.getStructureForDelete(eventRecords[0]);

        MessageDialog.confirm({
          title: 'Dialog Title',
          message: 'Are you sure to Delete?',
        }).then((result) => {
          if (result === 1) {
            this.planningService.deletePlanning(code, structure).subscribe(
              (responseData: any) => {
                this.loadTasks(true);
                context.finalize(true);
              },
              (err) => {
                context.finalize(false);
              }
            );
          } else {
            context.finalize(false);
          }
        });

        // Prevent default behaviour
        return false;
      }
    );

    // Reset del blocco di Bryntum
    localStorage.removeItem('b-schedulerpro-verify-date');
    localStorage.removeItem('b-schedulerpro-trial-start');

    this.schedulerPro.on('scheduleDblClick', ({ resourceRecord, date, tickStartDate }: any) => {
      const teamLeaderId = resourceRecord?.originalData?.id ?? resourceRecord?.id;
      const start = tickStartDate || date;
      const startDate = this.setDateToUTCZone(start);

      this.router.navigate(
        ['/planner', 'core', 'form'], // 👈 rotta light
        {
          queryParams: {
            teamLeaderId,
            startDate: startDate.toISOString()
          }
        }
      );
    });

  }

  getTeamLeader(id: any) {
    return this.teamLeaders.find((t: any) => t.id == id);
  }

  getAssistants(ids: any) {
    return this.assistants.filter((t: any) => ids.includes(t.id));
  }

  saveEvent(event: any) {
    console.log('SAVE');
    this.libService.lockPage('');

    const values = event.values;
    const assistantIds = values.assistants;
    const color = values.eventColor;
    const notes = (values.notes ?? '').toString().trim();

    const currentUser = this.userSessionService.getState('user');
    const code = event.eventRecord.id;

    const params = {
      code,
      assistants: this.getAssistants(assistantIds),
      currentUser: currentUser.email,
      authorId: currentUser.id,
      color,
      notes,
    };

    this.planningService.changeAssistants(code, params).subscribe(
      (responseData: any) => {
        // opzionale: allinea il record locale per riflettere subito le note
        event.eventRecord.set('notes', notes);
        this.libService.unlockPage();
        this.loadTasks(true);
        return true;
      },
      (err) => {
        this.libService.unlockPage();
        return false;
      }
    );
  }


  getStructureForDrop(context: any, currentUser: any) {
    let originalData = context.eventRecord.originalData;

    let id = originalData.groupId ?? originalData.id;
    let assistants = originalData.assistants;
    let startDate = this.setDateToUTCZone(context.startDate);
    let endDate = this.setDateToUTCZone(context.endDate);
    let newResource = context.newResource.originalData;
    let teamLeaderId = originalData.teamLeaderId;
    let orderId = originalData.orderId;

    return {
      id: id,
      assistants: assistants,
      startDate: startDate,
      endDate: endDate,
      resource: newResource,
      currentUser: currentUser.email,
      authorId: currentUser.id,
      teamLeaderId: teamLeaderId,
      orderId: orderId,
    };
  }

  setDateToUTCZone(date: any) {
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDate();
    let newDate = new Date(Date.UTC(year, month, day));
    return newDate;
  }

  getStructureForResize(
    context: any,
    startDate: any,
    endDate: any,
    currentUser: any
  ) {
    let originalData = context.eventRecord.originalData;
    let id = originalData.groupId ?? originalData.id;
    let assistants = originalData.assistants;
    let teamLeaderId = originalData.teamLeaderId;
    let orderId = originalData.orderId;

    return {
      id: id,
      assistants: assistants,
      startDate: startDate,
      endDate: endDate,
      currentUser: currentUser.email,
      authorId: currentUser.id,
      teamLeaderId: teamLeaderId,
      orderId: orderId,
    };
  }

  getStructureForDelete(eventRecord: any) {
    let originalData = eventRecord.originalData;
    let teamLeaderId = originalData.teamLeaderId;
    let orderId = originalData.orderId;

    return {
      teamLeaderId: teamLeaderId,
      orderId: orderId,
    };
  }

  getStructureForCopy(context: any, resources: any, currentUser: any) {
    let resource = context.resourceRecord.originalData;
    let eventRecords = context.eventRecords[0];
    let code = eventRecords.code;
    let assistants = eventRecords.assistants;

    let id = eventRecords.groupId ?? eventRecords.id;

    //let startDate = this.setDateToUTCZone(context.startDate)
    //let endDate = this.setDateToUTCZone(context.endDate)
    let structure = {
      id: id,
      resources: resources,
      newStartDate: this.setDateToUTCZone(context.date),
      // startDate: startDate,
      // endDate: endDate,
      currentUser: currentUser.email,
      authorId: currentUser.id,
    };

    return structure;
  }

  getCode(context: any) {
    let originalData = context.eventRecord.originalData;
    return originalData.id;
  }

  applySchedulerLocale = (schedulerLocale: string): void => {
    switch (schedulerLocale) {
      case 'it':
        LocaleManager.applyLocale(localeIt);
        break;
      case 'fr':
        LocaleManager.applyLocale(localeFr);
        break;
      case 'es':
        LocaleManager.applyLocale(localeEs);
        break;
      case 'en':
        LocaleManager.locale = 'En';
        break;
      default:
        LocaleManager.locale = 'En';
        break;
    }
  };

  getCashFlowIconAlert(percentageStatus: any = true) {
    let iconClass = '';
    if (!percentageStatus) iconClass = 'b-fa b-fa-triangle-exclamation redIcon'
    return iconClass;
  }
  getAbsenceIconAlert(hasAbsence: boolean) {
    // Stessa logica: se c'è, ritorno la classe; altrimenti stringa vuota
    return hasAbsence ? 'b-fa fa-umbrella-beach absence-corner' : '';
  }
  private pickIconCls(hasCashflow: boolean, hasAbsence: boolean): string {
    const ABS = 'b-fa b-fa-umbrella absence-corner redIcon';
    const CF = 'b-fa b-fa-euro-sign absence-corner redIcon';
    const BOTH5 = 'b-fa b-fa-exclamation-triangle absence-corner redIcon'; // FA5

    if (hasCashflow && hasAbsence) return BOTH5; // o BOTH6
    if (hasAbsence) return ABS;
    if (hasCashflow) return CF;
    return '';
  }

  /** YYYY-MM-DD locale */
  private ymdLocal(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  /** Giorni (YYYY-MM-DD) inclusivi tra due date (uso locali) */
  private listDaysYMD(start: Date, end: Date): string[] {
    const s = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    const e = new Date(end.getFullYear(), end.getMonth(), end.getDate());
    const out: string[] = [];
    for (let d = s; d <= e; d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1)) {
      out.push(this.ymdLocal(d));
    }
    return out;
  }

  /** Ritorna conflitti: [{ userId, name, days: ['YYYY-MM-DD', ...] }] */
  private findAbsenceConflicts(daysYMD: string[], participantIds: number[]) {
    const uniqIds = [...new Set(participantIds.filter((v): v is number => typeof v === 'number' && !Number.isNaN(v)))];
    const conflicts: Array<{ userId: number; name: string; days: string[] }> = [];

    for (const uid of uniqIds) {
      const set = this.absencesByUser[String(uid)];
      if (!set) continue;
      const hit = daysYMD.filter(d => set.has(d));
      if (hit.length) {
        conflicts.push({ userId: uid, name: this.idToUsername(uid), days: hit.sort() });
      }
    }
    return conflicts;
  }

  /** Mostra conferma con elenco assenze; true = prosegui */
  private async confirmAbsences(conflicts: Array<{ userId: number; name: string; days: string[] }>, mode: 'copy' | 'resize'): Promise<boolean> {
    const title = this.translate.instant(
      mode === 'copy'
        ? 'PLANNER.AbsenceConfirm.CopyTitle'
        : 'PLANNER.AbsenceConfirm.ResizeTitle'
    );

    const prefix = this.translate.instant('PLANNER.AbsenceConfirm.Prefix');
    const proceed = this.translate.instant('PLANNER.AbsenceConfirm.Proceed');

    const lines = conflicts.map(c => `• ${c.name}: ${c.days.join(', ')}`);
    const message = `${prefix}<br>${lines.join('<br>')}<br><br>${proceed}`;

    const res = await MessageDialog.confirm({ title, message });
    return res === 1; // 1 = OK/Yes
  }

  /** Giorni aggiunti dal resize (solo parte “nuova”) in YYYY-MM-DD */
  private getAddedDaysForResize(oldStart: Date, oldEnd: Date, newStart: Date, newEnd: Date): string[] {
    // normalizza (solo date, senza orario)
    const oS = new Date(oldStart.getFullYear(), oldStart.getMonth(), oldStart.getDate());
    const oE = new Date(oldEnd.getFullYear(), oldEnd.getMonth(), oldEnd.getDate());
    const nS = new Date(newStart.getFullYear(), newStart.getMonth(), newStart.getDate());
    const nE = new Date(newEnd.getFullYear(), newEnd.getMonth(), newEnd.getDate());

    // ampliamento a destra
    if (nE > oE && nS.getTime() === oS.getTime()) {
      const from = new Date(oE.getFullYear(), oE.getMonth(), oE.getDate() + 1);
      return this.listDaysYMD(from, nE);
    }
    // ampliamento a sinistra
    if (nS < oS && nE.getTime() === oE.getTime()) {
      const to = new Date(oS.getFullYear(), oS.getMonth(), oS.getDate() - 1);
      return this.listDaysYMD(nS, to);
    }
    // restringe o sposta senza ampliare → nessun controllo
    return [];
  }

  /** Ritorna elenco operatori e date (formattate) che hanno assenze nel set di giorni indicato */
  private getAbsenceConflictsFor(participantIds: number[], daysYMD: string[]): { users: string[]; dates: string[] } {
    const users = new Set<string>();
    const dates = new Set<string>();

    const uniqParticipants = [...new Set(participantIds.filter((v): v is number => typeof v === 'number' && !Number.isNaN(v)))];

    for (const uid of uniqParticipants) {
      const set = this.absencesByUser[String(uid)];
      if (!set) continue;

      for (const d of daysYMD) {
        if (set.has(d)) {
          users.add(this.idToUsername(uid));
          dates.add(moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY'));
        }
      }
    }

    // ordina le date dd/MM/yyyy
    const datesSorted = Array.from(dates).sort((a, b) => {
      const ma = moment(a, 'DD/MM/YYYY'), mb = moment(b, 'DD/MM/YYYY');
      return ma.valueOf() - mb.valueOf();
    });

    return { users: Array.from(users), dates: datesSorted };
  }

  /** YYYY-MM-DD locale */
  private ymd(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  /** Restituisce TUTTE le risorse che hanno assenze nel range [startDate, endDate] */
  private buildAbsenceSummaryForRange(startDate: Date, endDate: Date) {
    const yStart = this.ymd(startDate);
    const yEnd = this.ymd(endDate);

    // 1) raccogli TUTTI gli ID noti (team leader, assistenti, elenco completo)
    const ids = new Set<number>();

    // da mappa completa (popolata da financeGetRisorse -> upsertResources)
    for (const id of this.allResourcesById.keys()) ids.add(id);

    // fallback su liste “grezze” nel caso qualche sede non popoli allResourcesById
    (this.teamLeaders ?? []).forEach((u: any) => ids.add(Number(u.id)));
    (this.assistants ?? []).forEach((u: any) => ids.add(Number(u.id)));
    (this.resourcesList ?? []).forEach((u: any) => ids.add(Number(u.id)));

    // 2) per ogni utente, prendi le sue assenze dettagliate e filtra nel range
    const rows: Array<{
      userId: number;
      name: string;
      ruolo: string;
      NomeSede: string | null;
      days: Array<{ ymd: string; hours: number | null; causalCode: string | null }>;
      count: number;
    }> = [];

    for (const uid of ids) {
      const k = String(uid);
      const details = this.absencesDetailsByUser[k] ?? [];
      if (!details.length) continue;

      // filtra per intervallo (confronto stringhe YYYY-MM-DD è ok se stesso formato)
      const inRange = details.filter(d => d.ymd >= yStart && d.ymd <= yEnd);

      if (!inRange.length) continue;

      // metadati utente (cerca prima nella mappa "completa", poi fallback)
      const meta = this.allResourcesById.get(uid) ||
        (this.resourcesList || []).find((u: any) => Number(u.id) === uid) ||
        (this.teamLeaders || []).find((u: any) => Number(u.id) === uid) ||
        (this.assistants || []).find((u: any) => Number(u.id) === uid) || {};

      rows.push({
        userId: uid,
        name: meta?.name ?? String(uid),
        ruolo: meta?.ruolo ?? (meta?.role ?? ''),     // fallback se hai "role"
        NomeSede: meta?.NomeSede ?? null,
        days: inRange.sort((a, b) => a.ymd.localeCompare(b.ymd)),
        count: inRange.length
      });
    }

    // ordina: prima chi ha più assenze, poi alfabetico
    rows.sort((a, b) => b.count - a.count || a.name.localeCompare(b.name));
    return rows;
  }
  private buildResourcesIndex(): Record<string, { name: string; ruolo: string; NomeSede: string | null }> {
    const out: Record<string, { name: string; ruolo: string; NomeSede: string | null }> = {};

    // dalla mappa completa (se popolata)
    this.allResourcesById.forEach((v, k) => {
      out[String(k)] = { name: v.name, ruolo: v.ruolo, NomeSede: v.NomeSede ?? null };
    });

    // fallback: unisci liste già caricate
    const fold = (arr: any[] = [], ruoloFallback = '') =>
      arr.forEach(u => {
        const id = String(u.id);
        if (!out[id]) {
          out[id] = {
            name: u.name ?? id,
            ruolo: u.ruolo ?? u.role ?? ruoloFallback,
            NomeSede: u.NomeSede ?? u.nomeSede ?? null
          };
        }
      });

    fold(this.teamLeaders, 'Operaio Capo Squadra');
    fold(this.assistants, 'Operaio Assistente');
    fold(this.resourcesList);

    return out;
  }


  private getResourceTimeRangeStore() {
    // funziona su tutte le versioni Bryntum
    return (this.schedulerPro as any)?.features?.resourceTimeRanges?.store
      || (this.schedulerPro as any)?.resourceTimeRangeStore;
  }
  /** Crea/aggiorna i marker di assenza a livello cella (per risorsa/giorno) */
  /** Crea/aggiorna i marker di assenza per ogni cella risorsa×giorno, coerente UTC */
  private rebuildAbsenceDayMarkers(): void {
    if (!this.schedulerPro || this.plannerType !== 'core') return;

    const store = this.getResourceTimeRangeStore();
    if (!store) return;

    store.removeAll?.();

    // range selezionato (locale, clamp)
    const startLocal = new Date(this.planningStartDate.getFullYear(), this.planningStartDate.getMonth(), this.planningStartDate.getDate(), 0, 0, 0, 0);
    const endLocal = new Date(this.planningEndDate.getFullYear(), this.planningEndDate.getMonth(), this.planningEndDate.getDate(), 23, 59, 59, 999);

    const resourceIds: number[] = (this.schedulerPro.resourceStore?.records || [])
      .map((r: any) => Number(r.id))
      .filter(Number.isFinite);

    const toAdd: any[] = [];

    for (const rid of resourceIds) {
      const absSet: Set<string> | undefined = this.absencesByUser[String(rid)];
      if (!absSet || absSet.size === 0) continue;

      // scorri giorni locali ma confronta la chiave in UTC
      for (let d = new Date(startLocal); d <= endLocal; d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1)) {
        const utcKey = this.unixToYMD(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 1000); // YYYY-MM-DD in UTC
        if (!absSet.has(utcKey)) continue;

        const dayStartLocal = DateHelper.clearTime(new Date(d));               // 00:00 locale
        const dayEndLocal = DateHelper.add(dayStartLocal, 1, 'day');         // +1 giorno (locale)

        toAdd.push({
          id: `abs-${rid}-${utcKey}`,
          resourceId: rid,
          startDate: dayStartLocal,
          endDate: dayEndLocal,
          cls: 'absence-cell'
        });
      }
    }

    if (toAdd.length) store.add(toAdd);
  }

  /** YYYY-MM-DD in UTC (coerente con normalizeAbsences/unixToYMD) */
  private ymdUTC(d: Date): string {
    const y = d.getUTCFullYear();
    const m = String(d.getUTCMonth() + 1).padStart(2, '0');
    const day = String(d.getUTCDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  /** Restituisce il giorno UTC [00:00Z] corrispondente ad una data locale (solo data) */
  private asUtcMidnight(d: Date): Date {
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0));
  }
  // --- HELPER ---
  private safeDiv(num?: number | null, den?: number | null) {
    const n = Number(num), d = Number(den);
    if (!isFinite(n) || !isFinite(d) || d === 0) return 0;
    return n / d;
  }
  private round2(v: number | null | undefined) {
    return (v == null || !isFinite(Number(v))) ? 0 : Math.round(Number(v) * 100) / 100;
  }

  // Mappa cumulativa per ordine, popolata prima coi dati dei task e poi arricchita coi final balancer
  // mappa cumulativa per ordine
  private metricsByOrderId = new Map<number, {
    valueSold?: number;
    fatturato?: number;
    incassato?: number;
    PercIncMDO?: number;
    valoreMateriali?: number;
    valoreStorni?: number;
    valoreOreMlc?: number;
    valoreStorniDelibera?: number;     // 👈 NEW
    totalValoreSal?: number;           // (valore prodotto totale lordo)
    deliberateValueToBeProduced?: number;

    // derivati
    percentFatturato?: number;
    percentIncassato?: number;
    percentAvanzamento?: number;
    percentIncidenzaMateriale?: number;
    mlc?: number;                      // % MLC
    mlcValue?: number;                 // € MLC  👈 NEW
    mediaNetta?: number;               // 👈 NEW (ex MediaLorda)
    producedNet?: number;              // (prod. totale - storni)
    deliberateNet?: number;            // (deliberato - storni delibera)
  }>();



  private computeDerivedMetrics(m: any) {
    const valueSold = Number(m.valueSold ?? 0);
    const fatturato = Number(m.fatturato ?? 0);
    const incassato = Number(m.incassato ?? 0);

    const producedGross = Number(m.totalValoreSal ?? 0);        // valore prodotto totale (lordo)
    const storni = Number(m.valoreStorni ?? 0);
    const producedNet = producedGross - storni;

    const deliberateGross = Number(m.deliberateValueToBeProduced ?? 0);
    const storniDelibera = Number(m.valoreStorniDelibera ?? 0);
    const deliberateNet = deliberateGross - storniDelibera;

    const valoreMateriali = Number(m.valoreMateriali ?? 0);
    const valoreOreMlc = Number(m.valoreOreMlc ?? 0);

    // salva anche i netti per il tooltip
    m.producedNet = producedNet;
    m.deliberateNet = deliberateNet;

    // % Fatturato / Incassato
    m.percentFatturato = this.safeDiv(fatturato, valueSold) * 100;
    m.percentIncassato = this.safeDiv(incassato, valueSold) * 100;
    m.PercIncMDO = this.safeDiv(valoreOreMlc, producedNet) * 100;

    // 👇 % Avanzamento = (prodotto NETTO) / (deliberato NETTO)
    m.percentAvanzamento = this.safeDiv(producedNet, deliberateNet) * 100;

    // 👇 % Incidenza materiale (rinominata "Costo materiale") = materiali / (prodotto NETTO)
    m.percentIncidenzaMateriale = this.safeDiv(valoreMateriali, producedNet) * 100;

    // 👇 MLC
    // % (come prima, confermato da te)
    m.mlc = this.safeDiv(producedGross - storni - valoreOreMlc - valoreMateriali, producedGross) * 100;
    // € richiesto ora
    m.mlcValue = producedGross - storni - valoreOreMlc - valoreMateriali;

    // 👇 Media netta (ex media lorda). Formula invariata salvo rinomina
    m.mediaNetta = (valoreOreMlc > 0)
      ? (((8 * (producedGross - valoreMateriali)) / valoreOreMlc) * 2)
      : 0;

    // arrotondini
    const r2 = (x: any) => Math.round(Number(x) * 100) / 100;
    m.percentFatturato = r2(m.percentFatturato);
    m.percentIncassato = r2(m.percentIncassato);
    m.percentAvanzamento = r2(m.percentAvanzamento);
    m.percentIncidenzaMateriale = r2(m.percentIncidenzaMateriale);
    m.PercIncMDO = r2(m.PercIncMDO);
    m.mlc = r2(m.mlc);
    m.mlcValue = r2(m.mlcValue);
    m.mediaNetta = r2(m.mediaNetta);
    m.producedNet = r2(m.producedNet);
    m.deliberateNet = r2(m.deliberateNet);
  }

  /** Popola metricsByOrderId con i numeri base presi dalle task grezze */
  private seedMetricsFromRawTasks(): void {
    this.metricsByOrderId.clear();

    for (const t of (this.rawTasks || [])) {
      const oid = Number(t.orderId ?? t?.Order?.id);
      if (!Number.isFinite(oid)) continue;

      const m = this.metricsByOrderId.get(oid) || {};

      // numeri base che arrivano da getOrderAndTaskWithPagination
      m.valueSold = Number(t.valueSold ?? m.valueSold ?? 0);
      m.fatturato = Number(t.fatturato ?? m.fatturato ?? 0);
      m.incassato = Number(t.incassato ?? m.incassato ?? 0);
      m.valoreMateriali = Number((t.ValoreMateriali ?? (t as any).valoreMateriali) ?? m.valoreMateriali ?? 0);
      m.valoreStorni = Number((t.ValoreStorni ?? (t as any).valoreStorni) ?? m.valoreStorni ?? 0);
      m.valoreOreMlc = Number(t.valoreOreMlc ?? m.valoreOreMlc ?? 0);

      this.computeDerivedMetrics(m);
      this.metricsByOrderId.set(oid, m);
    }
  }
  private syncOrderIdsFromRawTasks(): void {
    this.orderIds = Array.from(new Set(
      (this.rawTasks || [])
        .map((t: any) => Number(t.orderId ?? t?.Order?.id))
        .filter(Number.isFinite)
    ));
  }

  /** Copia tutte le metriche calcolate (map) dentro gli eventi esistenti */
  private stampMetricsOnAllEvents(): void {
    for (const ev of (this.tasksEvents || [])) {
      const m = this.metricsByOrderId.get(ev.orderId);
      if (!m) continue;

      Object.assign(ev, {
        // già esistenti…
        ValoreFatturato: m.fatturato,
        ValoreIncassato: m.incassato,
        PercIncMDO: m.PercIncMDO,
        totalValoreSal: m.totalValoreSal,
        deliberateValueToBeProduced: m.deliberateValueToBeProduced,
        ValoreMateriali: m.valoreMateriali,
        ValoreStorni: m.valoreStorni,
        valoreOreMlc: m.valoreOreMlc,

        // percentuali
        PercentFatturato: m.percentFatturato,
        PercentIncassato: m.percentIncassato,
        PercentAvanzamento: m.percentAvanzamento,
        PercentIncidenzaMateriale: m.percentIncidenzaMateriale,

        // 👇 nuovi campi
        MLC: m.mlc,                 // % MLC
        MLCValue: m.mlcValue,       // € MLC
        MediaNetta: m.mediaNetta,   // rinominata
        ProducedNet: m.producedNet, // per eventuali debug/tooltip
        DeliberatoNet: m.deliberateNet
      });

    }
  }
  private loadTLDataFor(date: Date, idSede: number | string) {
    const { startYMD, endYMD, key } = this.monthRangeFor(date);
    if (this.lastMonthKey === key) return;
    this.lastMonthKey = key;

    const user = this.userSessionService.getState('user');

    const pian$ = this.financeService
      .getPlanningPianificazioneCapisquadra(user.email, startYMD, endYMD, idSede)
      .pipe(catchError(() => of({ item: { Table: [] } } as ApiItem<TLPlanningRow>)));

    const cons$ = this.financeService
      .getPlanningConsuntivazioneCapisquadra(user.email, startYMD, endYMD, idSede)
      .pipe(catchError(() => of({ item: { Table: [] } } as ApiItem<TLConsRow>)));

    forkJoin([pian$, cons$]).subscribe(([p, c]) => {
      this.planningByTL.clear();
      (p?.item?.Table ?? []).forEach((r: any) => {
        const id = Number(r.idCaposquadra);
        if (!Number.isNaN(id)) this.planningByTL.set(id, r);
      });

      this.consByTL.clear();
      (c?.item?.Table ?? []).forEach((r: any) => {
        const id = Number(r.idCaposquadra ?? -1);
        if (!Number.isNaN(id) && id > 0) this.consByTL.set(id, r);
      });
    });
  }

  private reloadForCurrentMonth() {
    const anchor = this.schedulerPro?.timeAxis?.startDate ? new Date(this.schedulerPro.timeAxis.startDate) : new Date();
    this.loadTLDataFor(anchor, this.getCompany());
  }
  /** Applica tutte le metriche (valori + %) su un record evento */
  private stampMetrics(target: any, m: any) {
    if (!m || !target) return;

    Object.assign(target, {
      // valori “base”
      ValoreFatturato: m.fatturato,
      ValoreIncassato: m.incassato,
      PercIncMDO: m.PercIncMDO,
      totalValoreSal: m.totalValoreSal,                 // prodotto lordo
      deliberateValueToBeProduced: m.deliberateValueToBeProduced,
      ValoreMateriali: m.valoreMateriali,
      ValoreStorni: m.valoreStorni,
      valoreOreMlc: m.valoreOreMlc,
      ValoreStorniDelibera: m.valoreStorniDelibera,     // NEW (se ti serve nel tooltip)

      // percentuali
      PercentFatturato: m.percentFatturato,
      PercentIncassato: m.percentIncassato,
      PercentAvanzamento: m.percentAvanzamento,         // già calcolata NET: producedNet/deliberateNet
      PercentIncidenzaMateriale: m.percentIncidenzaMateriale, // “Costo materiale” %

      // MLC
      MLC: m.mlc,               // % MLC
      MLCValue: m.mlcValue,     // € MLC (nuovo)

      // Media netta (ex MediaLorda)
      MediaNetta: m.mediaNetta,

      // netti (comodi per tooltip/debug)
      ProducedNet: m.producedNet,      // totalValoreSal - storni
      DeliberatoNet: m.deliberateNet,  // deliberate - storni delibera
    });
  }
  /** Replica l'effetto della ricerca-vuota: applica i filtri come in filterEvents(''),
 * poi li rimuove e riordina le risorse (così i CSQ con eventi stanno in alto). */
  private kickOrderingLikeSearch(): void {
    if (!this.schedulerPro) return;

    const rx = new RegExp('', 'i'); // matcha sempre

    // 1) Applica i 2 filtri come fai in filterEvents
    this.schedulerPro.eventStore.filter({
      filters: (ev: any) => String(ev.name || '').match(rx),
      replace: true
    });
    this.schedulerPro.resourceStore.filter({
      filters: (res: any) => (res?.events || []).some((e: any) => String(e.name || '').match(rx)),
      replace: true
    });

    // 2) Subito dopo, ripulisci i filtri per tornare alla lista completa
    this.schedulerPro.eventStore.clearFilters?.();
    this.schedulerPro.resourceStore.clearFilters?.();

    // 3) Applica l’ordinamento che mette in alto chi ha almeno un evento nel range visibile
    this.updateResourceOrdering();
  }

  /** Forza l'ordinamento: prima risorse con almeno 1 evento nel range visibile, poi le altre (alfabetico) */
  private updateResourceOrdering(): void {
    if (!this.schedulerPro) return;

    const axisStart: Date = this.schedulerPro.timeAxis.startDate;
    const axisEnd: Date = this.schedulerPro.timeAxis.endDate;

    const hasEventInView = (res: any): boolean => {
      const evts = (res?.events ?? []) as any[];
      if (!evts.length) return false;
      return evts.some(e => {
        const s = e.startDate instanceof Date ? e.startDate : new Date(e.startDate);
        const en = e.endDate instanceof Date ? e.endDate : new Date(e.endDate);
        // overlap con l'intervallo visibile
        return s < axisEnd && en > axisStart;
      });
    };

    // ordina: prima chi ha eventi visibili, poi alfabetico per nome
    this.schedulerPro.resourceStore.sort((a: any, b: any) => {
      const aHas = hasEventInView(a) ? 1 : 0;
      const bHas = hasEventInView(b) ? 1 : 0;
      if (aHas !== bHas) return bHas - aHas; // chi ha eventi (1) viene prima
      const an = (a.get ? a.get('name') : a.name) ?? '';
      const bn = (b.get ? b.get('name') : b.name) ?? '';
      return String(an).localeCompare(String(bn));
    });
  }


  /** Normalizza il ts (sec) all’inizio giorno UTC, per confronto contiguità */
  private toDayStartUtc(tsSec: number): number {
    const d = new Date(tsSec * 1000);
    return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()) / 1000;
  }

  /** Spezza l’elenco di giorni (ts sec) in segmenti contigui (passo = 86400 sec) */
  private splitIntoContiguousDaySegments(daysTsSec: number[]): number[][] {
    const DAY = 86400;
    const uniq = Array.from(new Set(daysTsSec.map(ts => this.toDayStartUtc(ts)))).sort((a, b) => a - b);
    if (!uniq.length) return [];
    const segments: number[][] = [];
    let cur: number[] = [uniq[0]];
    for (let i = 1; i < uniq.length; i++) {
      if (uniq[i] === uniq[i - 1] + DAY) cur.push(uniq[i]);
      else { segments.push(cur); cur = [uniq[i]]; }
    }
    segments.push(cur);
    return segments;
  }

  /** end esclusivo: giorno successivo alle 00:00 (inclusione visiva del giorno) */
  private dayEndExclusive(tsDayStartUtcSec: number): Date {
    return new Date((tsDayStartUtcSec + 86400) * 1000);
  }
  /** Ritorna la data locale di quel ts (sec) alle HH:mm esatte */
  private atLocalHour(tsSec: number, hour: number, minute = 0): Date {
    const d = new Date(tsSec * 1000);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), hour, minute, 0, 0);
  }

  /** Come sopra ma da una Date locale (già “giorno giusto”) */
  private sameDayAtLocalHour(d: Date, hour: number, minute = 0): Date {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), hour, minute, 0, 0);
  }


}
interface ResourceBasic {
  id: number;
  name: string;
  ruolo: string;
  NomeSede: string | null;
}
// Tipi per la risposta
type TLPlanningRow = {
  idCaposquadra: number;
  ProgrammatoCsq: number;
  ProgrammatoSquadraStandardNetto: number;
  SogliaPremioProgrammazione: number;
  PremioCsqTeorico: number;
  GettoneCsqTeorico: number;
};

type TLConsRow = {
  idCaposquadra: number | null;
  AvanzamentoProduzione: number;
  CostoMateriali: number;
  ['Materiali%']: number;
  CostoMDO: number;
  ['MDO%']: number;
  MLC: number;
  ['MLC%']: number;
  AvanzamentoProduzioneSQST: number;
};
type ApiItem<T> = { esito?: string; item?: { Table?: T[] } };

type TLPlanningResponse = {
  esito?: string;
  item?: { Table?: TLPlanningRow[] };
};